(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
	}));
});



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = elm$core$Set$toList(x);
		y = elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.av.U === region.aJ.U)
	{
		return 'on line ' + region.av.U;
	}
	return 'on lines ' + region.av.U + ' through ' + region.aJ.U;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? elm$core$Maybe$Nothing
		: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




/**_UNUSED/
function _Json_errorToString(error)
{
	return elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? elm$core$Result$Ok(value)
		: (value instanceof String)
			? elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!elm$core$Result$isOk(result))
					{
						return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if (elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));

		case 1:
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!elm$core$Result$isOk(result))
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.bP,
		impl.b9,
		impl.b5,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.bH.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.bH.b, xhr)); });
		elm$core$Maybe$isJust(request.b8) && _Http_track(router, xhr, request.b8.a);

		try {
			xhr.open(request.bT, request.ca, true);
		} catch (e) {
			return done(elm$http$Http$BadUrl_(request.ca));
		}

		_Http_configureRequest(xhr, request);

		request.bz.a && xhr.setRequestHeader('Content-Type', request.bz.a);
		xhr.send(request.bz.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.bL; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.b7.a || 0;
	xhr.responseType = request.bH.d;
	xhr.withCredentials = request.H;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		ca: xhr.responseURL,
		bk: xhr.status,
		b3: xhr.statusText,
		bL: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return elm$core$Dict$empty;
	}

	var headers = elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3(elm$core$Dict$update, key, function(oldValue) {
				return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
			b1: event.loaded,
			as: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
			b$: event.loaded,
			as: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
		}))));
	});
}



// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (
		(typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		||
		(Array.isArray(_Json_unwrap(value)) && _VirtualDom_RE_js_html.test(String(_Json_unwrap(value))))
	)
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2(elm$json$Json$Decode$map, func, handler.a)
				:
			A3(elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		y: func(record.y),
		ax: record.ax,
		ar: record.ar
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.y;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.ax;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.ar) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.a_) { flags += 'm'; }
	if (options.aA) { flags += 'i'; }

	try
	{
		return elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? elm$core$Maybe$Just(submatch)
				: elm$core$Maybe$Nothing;
		}
		out.push(A4(elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? elm$core$Maybe$Just(submatch)
				: elm$core$Maybe$Nothing;
		}
		return replacer(A4(elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.bP,
		impl.b9,
		impl.b5,
		function(sendToApp, initialModel) {
			var view = impl.cb;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.bP,
		impl.b9,
		impl.b5,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl._ && impl._(sendToApp)
			var view = impl.cb;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.bz);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.br) && (_VirtualDom_doc.title = title = doc.br);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.bX;
	var onUrlRequest = impl.bY;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		_: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.a6 === next.a6
							&& curr.aT === next.aT
							&& curr.a2.a === next.a2.a
						)
							? elm$browser$Browser$Internal(next)
							: elm$browser$Browser$External(href)
					));
				}
			});
		},
		bP: function(flags)
		{
			return A3(impl.bP, flags, _Browser_getUrl(), key);
		},
		cb: impl.cb,
		b9: impl.b9,
		b5: impl.b5
	});
}

function _Browser_getUrl()
{
	return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { bM: 'hidden', bB: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { bM: 'mozHidden', bB: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { bM: 'msHidden', bB: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { bM: 'webkitHidden', bB: 'webkitvisibilitychange' }
		: { bM: 'hidden', bB: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		bg: _Browser_getScene(),
		bt: {
			bv: _Browser_window.pageXOffset,
			cd: _Browser_window.pageYOffset,
			bu: _Browser_doc.documentElement.clientWidth,
			aR: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		bu: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		aR: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			bg: {
				bu: node.scrollWidth,
				aR: node.scrollHeight
			},
			bt: {
				bv: node.scrollLeft,
				cd: node.scrollTop,
				bu: node.clientWidth,
				aR: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			bg: _Browser_getScene(),
			bt: {
				bv: x,
				cd: y,
				bu: _Browser_doc.documentElement.clientWidth,
				aR: _Browser_doc.documentElement.clientHeight
			},
			bG: {
				bv: x + rect.left,
				cd: y + rect.top,
				bu: rect.width,
				aR: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return elm$core$Maybe$Nothing;
	}
}



// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && elm$core$Maybe$isJust(options.aG))
		{
			lang = options.aG.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.aP.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.b6,
		breaks: gfm && gfm.bA,
		sanitize: options.bf,
		smartypants: options.bi
	};
}
var author$project$Main$ChangedUrl = function (a) {
	return {$: 0, a: a};
};
var author$project$Main$ClickedLink = function (a) {
	return {$: 1, a: a};
};
var author$project$Components$Body$Model = function (socials) {
	return {au: socials};
};
var author$project$Components$SocialsList$Model = F4(
	function (email, telegram, github, linkedin) {
		return {aI: email, aO: github, aY: linkedin, bq: telegram};
	});
var elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var elm$core$Array$branchFactor = 32;
var elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var elm$core$Basics$EQ = 1;
var elm$core$Basics$GT = 2;
var elm$core$Basics$LT = 0;
var elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3(elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var elm$core$List$cons = _List_cons;
var elm$core$Dict$toList = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var elm$core$Dict$keys = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2(elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var elm$core$Set$toList = function (_n0) {
	var dict = _n0;
	return elm$core$Dict$keys(dict);
};
var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var elm$core$Array$foldr = F3(
	function (func, baseCase, _n0) {
		var tree = _n0.c;
		var tail = _n0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			elm$core$Elm$JsArray$foldr,
			helper,
			A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var elm$core$Array$toList = function (array) {
	return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
};
var elm$core$Basics$ceiling = _Basics_ceiling;
var elm$core$Basics$fdiv = _Basics_fdiv;
var elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var elm$core$Basics$toFloat = _Basics_toFloat;
var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
	A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
var elm$core$Elm$JsArray$empty = _JsArray_empty;
var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
var elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var elm$core$List$reverse = function (list) {
	return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
};
var elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
			var node = _n0.a;
			var remainingNodes = _n0.b;
			var newAcc = A2(
				elm$core$List$cons,
				elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var elm$core$Basics$eq = _Utils_equal;
var elm$core$Tuple$first = function (_n0) {
	var x = _n0.a;
	return x;
};
var elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var elm$core$Basics$add = _Basics_add;
var elm$core$Basics$floor = _Basics_floor;
var elm$core$Basics$gt = _Utils_gt;
var elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var elm$core$Basics$mul = _Basics_mul;
var elm$core$Basics$sub = _Basics_sub;
var elm$core$Elm$JsArray$length = _JsArray_length;
var elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.e) {
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.f),
				elm$core$Array$shiftStep,
				elm$core$Elm$JsArray$empty,
				builder.f);
		} else {
			var treeLen = builder.e * elm$core$Array$branchFactor;
			var depth = elm$core$Basics$floor(
				A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.g) : builder.g;
			var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.e);
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.f) + treeLen,
				A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
				tree,
				builder.f);
		}
	});
var elm$core$Basics$False = 1;
var elm$core$Basics$idiv = _Basics_idiv;
var elm$core$Basics$lt = _Utils_lt;
var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					elm$core$Array$builderToArray,
					false,
					{g: nodeList, e: (len / elm$core$Array$branchFactor) | 0, f: tail});
			} else {
				var leaf = elm$core$Array$Leaf(
					A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var elm$core$Basics$le = _Utils_le;
var elm$core$Basics$remainderBy = _Basics_remainderBy;
var elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return elm$core$Array$empty;
		} else {
			var tailLen = len % elm$core$Array$branchFactor;
			var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
			return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var elm$core$Maybe$Nothing = {$: 1};
var elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var elm$core$Basics$True = 0;
var elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var elm$core$Basics$and = _Basics_and;
var elm$core$Basics$append = _Utils_append;
var elm$core$Basics$or = _Basics_or;
var elm$core$Char$toCode = _Char_toCode;
var elm$core$Char$isLower = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var elm$core$Char$isUpper = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var elm$core$Char$isAlpha = function (_char) {
	return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
};
var elm$core$Char$isDigit = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var elm$core$Char$isAlphaNum = function (_char) {
	return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
};
var elm$core$List$length = function (xs) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (_n0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var elm$core$List$map2 = _List_map2;
var elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2(elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var elm$core$List$range = F2(
	function (lo, hi) {
		return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$map2,
			f,
			A2(
				elm$core$List$range,
				0,
				elm$core$List$length(xs) - 1),
			xs);
	});
var elm$core$String$all = _String_all;
var elm$core$String$fromInt = _String_fromNumber;
var elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var elm$core$String$uncons = _String_uncons;
var elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var elm$json$Json$Decode$indent = function (str) {
	return A2(
		elm$core$String$join,
		'\n    ',
		A2(elm$core$String$split, '\n', str));
};
var elm$json$Json$Encode$encode = _Json_encode;
var elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
			elm$json$Json$Decode$errorToString(error))));
	});
var elm$json$Json$Decode$errorToString = function (error) {
	return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _n1 = elm$core$String$uncons(f);
						if (_n1.$ === 1) {
							return false;
						} else {
							var _n2 = _n1.a;
							var _char = _n2.a;
							var rest = _n2.b;
							return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + (elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
								elm$core$List$length(errors)) + ' ways:'));
							return A2(
								elm$core$String$join,
								'\n\n',
								A2(
									elm$core$List$cons,
									introduction,
									A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								elm$core$String$join,
								'',
								elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + (elm$json$Json$Decode$indent(
						A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var elm$json$Json$Decode$field = _Json_decodeField;
var elm$json$Json$Decode$map4 = _Json_map4;
var elm$json$Json$Decode$map = _Json_map1;
var elm$json$Json$Decode$oneOf = _Json_oneOf;
var elm$json$Json$Decode$succeed = _Json_succeed;
var elm$json$Json$Decode$maybe = function (decoder) {
	return elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder),
				elm$json$Json$Decode$succeed(elm$core$Maybe$Nothing)
			]));
};
var elm$json$Json$Decode$string = _Json_decodeString;
var author$project$Components$Body$socialsDecoder = A5(
	elm$json$Json$Decode$map4,
	author$project$Components$SocialsList$Model,
	A2(
		elm$json$Json$Decode$field,
		'email',
		elm$json$Json$Decode$maybe(elm$json$Json$Decode$string)),
	A2(
		elm$json$Json$Decode$field,
		'telegram',
		elm$json$Json$Decode$maybe(elm$json$Json$Decode$string)),
	A2(
		elm$json$Json$Decode$field,
		'github',
		elm$json$Json$Decode$maybe(elm$json$Json$Decode$string)),
	A2(
		elm$json$Json$Decode$field,
		'linkedin',
		elm$json$Json$Decode$maybe(elm$json$Json$Decode$string)));
var author$project$Components$Body$decodeSocialsField = A2(
	elm$json$Json$Decode$map,
	author$project$Components$Body$Model,
	A2(elm$json$Json$Decode$field, 'socials', author$project$Components$Body$socialsDecoder));
var elm$json$Json$Decode$decodeValue = _Json_run;
var author$project$Components$Body$decodeSocials = function (value) {
	var decoded = A2(elm$json$Json$Decode$decodeValue, author$project$Components$Body$decodeSocialsField, value);
	if (!decoded.$) {
		var result = decoded.a;
		return result.au;
	} else {
		return A4(author$project$Components$SocialsList$Model, elm$core$Maybe$Nothing, elm$core$Maybe$Nothing, elm$core$Maybe$Nothing, elm$core$Maybe$Nothing);
	}
};
var author$project$Components$Body$init = function (flags) {
	return {
		au: author$project$Components$Body$decodeSocials(flags)
	};
};
var author$project$Common$Link = F2(
	function (link, current) {
		return {bD: current, bR: link};
	});
var author$project$Components$Sidebar$linksPartial = _List_fromArray(
	[
		author$project$Common$Link('/'),
		author$project$Common$Link('/projects'),
		author$project$Common$Link('/blog'),
		author$project$Common$Link('/notes'),
		author$project$Common$Link('/socials')
	]);
var elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							elm$core$List$foldl,
							fn,
							acc,
							elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var author$project$Components$Sidebar$init = function (str) {
	return {
		V: A2(
			elm$core$List$map,
			function (partial) {
				return partial(
					_Utils_eq(
						partial(false).bR,
						str));
			},
			author$project$Components$Sidebar$linksPartial)
	};
};
var author$project$Main$Components = F2(
	function (body, bar) {
		return {T: bar, bz: body};
	});
var author$project$Main$ChangedPage = function (a) {
	return {$: 2, a: a};
};
var author$project$Main$Home = function (a) {
	return {$: 1, a: a};
};
var author$project$Main$Model = F5(
	function (components, flags, key, contentModel, page) {
		return {x: components, q: contentModel, aM: flags, ao: key, a0: page};
	});
var author$project$Main$NotFound = {$: 0};
var author$project$Main$Socials = function (a) {
	return {$: 5, a: a};
};
var author$project$Main$Blog = function (a) {
	return {$: 3, a: a};
};
var author$project$Main$GotBlogMsg = function (a) {
	return {$: 5, a: a};
};
var author$project$Main$GotNotesMsg = function (a) {
	return {$: 6, a: a};
};
var author$project$Main$GotProjectsMsg = function (a) {
	return {$: 4, a: a};
};
var author$project$Main$Notes = function (a) {
	return {$: 4, a: a};
};
var author$project$Main$Projects = function (a) {
	return {$: 2, a: a};
};
var author$project$Content$Blog = 1;
var author$project$Pages$Blog$Init$sourceDecoder = A2(elm$json$Json$Decode$field, 'blog-source', elm$json$Json$Decode$string);
var author$project$Pages$Blog$Init$decodeSource = function (flags) {
	var resultSource = A2(elm$json$Json$Decode$decodeValue, author$project$Pages$Blog$Init$sourceDecoder, flags);
	if (!resultSource.$) {
		var src = resultSource.a;
		return src;
	} else {
		return '';
	}
};
var author$project$Content$FetchContent = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
var elm$core$Basics$compare = _Utils_compare;
var elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _n1 = A2(elm$core$Basics$compare, targetKey, key);
				switch (_n1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var elm$core$Dict$Black = 1;
var elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var elm$core$Dict$Red = 0;
var elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _n1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _n3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _n5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _n6 = left.d;
				var _n7 = _n6.a;
				var llK = _n6.b;
				var llV = _n6.c;
				var llLeft = _n6.d;
				var llRight = _n6.e;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _n1 = A2(elm$core$Basics$compare, key, nKey);
			switch (_n1) {
				case 0:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3(elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3(elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
		if ((_n0.$ === -1) && (!_n0.a)) {
			var _n1 = _n0.a;
			var k = _n0.b;
			var v = _n0.c;
			var l = _n0.d;
			var r = _n0.e;
			return A5(elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _n0;
			return x;
		}
	});
var elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n1 = dict.d;
			var lClr = _n1.a;
			var lK = _n1.b;
			var lV = _n1.c;
			var lLeft = _n1.d;
			var lRight = _n1.e;
			var _n2 = dict.e;
			var rClr = _n2.a;
			var rK = _n2.b;
			var rV = _n2.c;
			var rLeft = _n2.d;
			var _n3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _n2.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5(elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n4 = dict.d;
			var lClr = _n4.a;
			var lK = _n4.b;
			var lV = _n4.c;
			var lLeft = _n4.d;
			var lRight = _n4.e;
			var _n5 = dict.e;
			var rClr = _n5.a;
			var rK = _n5.b;
			var rV = _n5.c;
			var rLeft = _n5.d;
			var rRight = _n5.e;
			if (clr === 1) {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n1 = dict.d;
			var lClr = _n1.a;
			var lK = _n1.b;
			var lV = _n1.c;
			var _n2 = _n1.d;
			var _n3 = _n2.a;
			var llK = _n2.b;
			var llV = _n2.c;
			var llLeft = _n2.d;
			var llRight = _n2.e;
			var lRight = _n1.e;
			var _n4 = dict.e;
			var rClr = _n4.a;
			var rK = _n4.b;
			var rV = _n4.c;
			var rLeft = _n4.d;
			var rRight = _n4.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5(elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n5 = dict.d;
			var lClr = _n5.a;
			var lK = _n5.b;
			var lV = _n5.c;
			var lLeft = _n5.d;
			var lRight = _n5.e;
			var _n6 = dict.e;
			var rClr = _n6.a;
			var rK = _n6.b;
			var rV = _n6.c;
			var rLeft = _n6.d;
			var rRight = _n6.e;
			if (clr === 1) {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _n1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_n2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _n3 = right.a;
							var _n4 = right.d;
							var _n5 = _n4.a;
							return elm$core$Dict$moveRedRight(dict);
						} else {
							break _n2$2;
						}
					} else {
						var _n6 = right.a;
						var _n7 = right.d;
						return elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _n2$2;
				}
			}
			return dict;
		}
	});
var elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _n3 = lLeft.a;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			} else {
				var _n4 = elm$core$Dict$moveRedLeft(dict);
				if (_n4.$ === -1) {
					var nColor = _n4.a;
					var nKey = _n4.b;
					var nValue = _n4.c;
					var nLeft = _n4.d;
					var nRight = _n4.e;
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _n4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _n6 = lLeft.a;
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _n7 = elm$core$Dict$moveRedLeft(dict);
						if (_n7.$ === -1) {
							var nColor = _n7.a;
							var nKey = _n7.b;
							var nValue = _n7.c;
							var nLeft = _n7.d;
							var nRight = _n7.e;
							return A5(
								elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2(elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2(elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _n1 = elm$core$Dict$getMin(right);
				if (_n1.$ === -1) {
					var minKey = _n1.b;
					var minValue = _n1.c;
					return A5(
						elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						elm$core$Dict$removeMin(right));
				} else {
					return elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2(elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var elm$core$Dict$remove = F2(
	function (key, dict) {
		var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
		if ((_n0.$ === -1) && (!_n0.a)) {
			var _n1 = _n0.a;
			var k = _n0.b;
			var v = _n0.c;
			var l = _n0.d;
			var r = _n0.e;
			return A5(elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _n0;
			return x;
		}
	});
var elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _n0 = alter(
			A2(elm$core$Dict$get, targetKey, dictionary));
		if (!_n0.$) {
			var value = _n0.a;
			return A3(elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2(elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var elm$core$Platform$sendToApp = _Platform_sendToApp;
var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return elm$core$Result$Err(e);
		}
	});
var elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var elm$http$Http$NetworkError_ = {$: 2};
var elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$Timeout_ = {$: 1};
var elm$http$Http$emptyBody = _Http_emptyBody;
var elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var elm$core$Basics$identity = function (x) {
	return x;
};
var elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			elm$core$Basics$identity,
			A2(elm$core$Basics$composeR, toResult, toMsg));
	});
var elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return elm$core$Result$Err(
				f(e));
		}
	});
var elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$NetworkError = {$: 2};
var elm$http$Http$Timeout = {$: 1};
var elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return elm$core$Result$Err(
					elm$http$Http$BadUrl(url));
			case 1:
				return elm$core$Result$Err(elm$http$Http$Timeout);
			case 2:
				return elm$core$Result$Err(elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return elm$core$Result$Err(
					elm$http$Http$BadStatus(metadata.bk));
			default:
				var body = response.b;
				return A2(
					elm$core$Result$mapError,
					elm$http$Http$BadBody,
					toResult(body));
		}
	});
var elm$http$Http$expectString = function (toMsg) {
	return A2(
		elm$http$Http$expectStringResponse,
		toMsg,
		elm$http$Http$resolve(elm$core$Result$Ok));
};
var elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var elm$core$Task$succeed = _Scheduler_succeed;
var elm$http$Http$State = F2(
	function (reqs, subs) {
		return {a9: reqs, bl: subs};
	});
var elm$http$Http$init = elm$core$Task$succeed(
	A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
var elm$core$Task$andThen = _Scheduler_andThen;
var elm$core$Process$kill = _Scheduler_kill;
var elm$core$Process$spawn = _Scheduler_spawn;
var elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _n2 = A2(elm$core$Dict$get, tracker, reqs);
					if (_n2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _n2.a;
						return A2(
							elm$core$Task$andThen,
							function (_n3) {
								return A3(
									elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2(elm$core$Dict$remove, tracker, reqs));
							},
							elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						elm$core$Task$andThen,
						function (pid) {
							var _n4 = req.b8;
							if (_n4.$ === 1) {
								return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _n4.a;
								return A3(
									elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3(elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			elm$core$Task$andThen,
			function (reqs) {
				return elm$core$Task$succeed(
					A2(elm$http$Http$State, reqs, subs));
			},
			A3(elm$http$Http$updateReqs, router, cmds, state.a9));
	});
var elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _n0 = f(mx);
		if (!_n0.$) {
			var x = _n0.a;
			return A2(elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return A2(
					elm$core$Task$andThen,
					function (b) {
						return elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var elm$core$Task$sequence = function (tasks) {
	return A3(
		elm$core$List$foldr,
		elm$core$Task$map2(elm$core$List$cons),
		elm$core$Task$succeed(_List_Nil),
		tasks);
};
var elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _n0) {
		var actualTracker = _n0.a;
		var toMsg = _n0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
			A2(
				elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : elm$core$Maybe$Nothing;
	});
var elm$http$Http$onSelfMsg = F3(
	function (router, _n0, state) {
		var tracker = _n0.a;
		var progress = _n0.b;
		return A2(
			elm$core$Task$andThen,
			function (_n1) {
				return elm$core$Task$succeed(state);
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$filterMap,
					A3(elm$http$Http$maybeSend, router, tracker, progress),
					state.bl)));
	});
var elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return elm$http$Http$Request(
				{
					H: r.H,
					bz: r.bz,
					bH: A2(_Http_mapExpect, func, r.bH),
					bL: r.bL,
					bT: r.bT,
					b7: r.b7,
					b8: r.b8,
					ca: r.ca
				});
		}
	});
var elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$http$Http$subMap = F2(
	function (func, _n0) {
		var tracker = _n0.a;
		var toMsg = _n0.b;
		return A2(
			elm$http$Http$MySub,
			tracker,
			A2(elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
var elm$http$Http$command = _Platform_leaf('Http');
var elm$http$Http$subscription = _Platform_leaf('Http');
var elm$http$Http$request = function (r) {
	return elm$http$Http$command(
		elm$http$Http$Request(
			{H: false, bz: r.bz, bH: r.bH, bL: r.bL, bT: r.bT, b7: r.b7, b8: r.b8, ca: r.ca}));
};
var author$project$Api$fetch = F2(
	function (t, url) {
		return elm$http$Http$request(
			{
				bz: elm$http$Http$emptyBody,
				bH: elm$http$Http$expectString(
					A2(
						elm$core$Basics$composeL,
						t,
						elm$core$Result$withDefault(''))),
				bL: _List_Nil,
				bT: 'GET',
				b7: elm$core$Maybe$Nothing,
				b8: elm$core$Maybe$Nothing,
				ca: url
			});
	});
var author$project$Common$metaFilename = 'index_meta.yaml';
var elm$json$Json$Decode$map2 = _Json_map2;
var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var elm$html$Html$div = _VirtualDom_node('div');
var elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var elm$html$Html$Attributes$style = elm$virtual_dom$VirtualDom$style;
var author$project$Components$EmptyElement$view = A2(
	elm$html$Html$div,
	_List_fromArray(
		[
			A2(elm$html$Html$Attributes$style, 'display', 'none')
		]),
	_List_Nil);
var author$project$Content$GotMetas = function (a) {
	return {$: 2, a: a};
};
var author$project$Content$LoadingMeta = 1;
var author$project$Content$Model = function (state) {
	return function (metas) {
		return function (source) {
			return function (slug) {
				return function (query) {
					return function (raw) {
						return function (dom) {
							return function (fragment) {
								return function (page) {
									return function (toc) {
										return {aH: dom, an: fragment, K: metas, a0: page, O: query, Z: raw, at: slug, am: source, aa: state, E: toc};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var author$project$Content$init = F5(
	function (path, filename, query, fragment, page) {
		return _Utils_Tuple2(
			author$project$Content$Model(1)(_List_Nil)(path)(filename)(query)(elm$core$Maybe$Nothing)(author$project$Components$EmptyElement$view)(fragment)(page)(elm$core$Maybe$Nothing),
			A2(
				author$project$Api$fetch,
				author$project$Content$GotMetas,
				_Utils_ap(path, author$project$Common$metaFilename)));
	});
var author$project$Content$DoEmbed = function (a) {
	return {$: 4, a: a};
};
var author$project$Content$DoScroll = function (a) {
	return {$: 5, a: a};
};
var author$project$Content$GotContent = function (a) {
	return {$: 0, a: a};
};
var author$project$Content$GotToc = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$Content$LoadingContent = 0;
var author$project$Content$NoOp = function (a) {
	return {$: 6, a: a};
};
var author$project$Content$PrepareContent = 2;
var author$project$Content$Ready = 3;
var author$project$Content$Meta = F8(
	function (title, date, description, link, tags, status, slug, toc) {
		return {aE: date, bE: description, bR: link, at: slug, aw: status, bp: tags, br: title, E: toc};
	});
var myrho$yaml$Yaml$Decode$Decoder = elm$core$Basics$identity;
var myrho$yaml$Yaml$Decode$Decoding = function (a) {
	return {$: 1, a: a};
};
var elm$core$String$fromFloat = _String_fromNumber;
var myrho$yaml$Yaml$Parser$Ast$toString = function (value) {
	switch (value.$) {
		case 0:
			var string = value.a;
			return '\"' + (string + '\"');
		case 1:
			var _float = value.a;
			return elm$core$String$fromFloat(_float) + ' (float)';
		case 2:
			var _int = value.a;
			return elm$core$String$fromInt(_int) + ' (int)';
		case 3:
			var list = value.a;
			return '[ ' + (A2(
				elm$core$String$join,
				', ',
				A2(elm$core$List$map, myrho$yaml$Yaml$Parser$Ast$toString, list)) + ' ]');
		case 4:
			var properties = value.a;
			return '{ ' + (A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					myrho$yaml$Yaml$Parser$Ast$toStringProperty,
					elm$core$Dict$toList(properties))) + ' }');
		case 5:
			if (value.a) {
				return 'True (bool)';
			} else {
				return 'False (bool)';
			}
		case 6:
			return 'Null';
		case 7:
			var name = value.a;
			var r_val = value.b;
			return '&' + (name + (' ' + myrho$yaml$Yaml$Parser$Ast$toString(r_val)));
		default:
			var name = value.a;
			return '*' + name;
	}
};
var myrho$yaml$Yaml$Parser$Ast$toStringProperty = function (_n0) {
	var name = _n0.a;
	var value = _n0.b;
	return name + (': ' + myrho$yaml$Yaml$Parser$Ast$toString(value));
};
var myrho$yaml$Yaml$Decode$decodeError = F2(
	function (expected, got) {
		return elm$core$Result$Err(
			myrho$yaml$Yaml$Decode$Decoding(
				'Expected ' + (expected + (', got: ' + myrho$yaml$Yaml$Parser$Ast$toString(got)))));
	});
var myrho$yaml$Yaml$Decode$bool = function (v) {
	if (v.$ === 5) {
		var bool_ = v.a;
		return elm$core$Result$Ok(bool_);
	} else {
		return A2(myrho$yaml$Yaml$Decode$decodeError, 'bool', v);
	}
};
var myrho$yaml$Yaml$Decode$fromValue = F2(
	function (_n0, v) {
		var decoder = _n0;
		return decoder(v);
	});
var myrho$yaml$Yaml$Decode$find = F3(
	function (names, decoder, v0) {
		find:
		while (true) {
			if (names.b) {
				var name = names.a;
				var rest = names.b;
				if (v0.$ === 4) {
					var properties = v0.a;
					var _n2 = A2(elm$core$Dict$get, name, properties);
					if (!_n2.$) {
						var v1 = _n2.a;
						var $temp$names = rest,
							$temp$decoder = decoder,
							$temp$v0 = v1;
						names = $temp$names;
						decoder = $temp$decoder;
						v0 = $temp$v0;
						continue find;
					} else {
						return elm$core$Result$Err(
							myrho$yaml$Yaml$Decode$Decoding('Expected property: ' + name));
					}
				} else {
					return elm$core$Result$Err(
						myrho$yaml$Yaml$Decode$Decoding('Expected record'));
				}
			} else {
				return A2(myrho$yaml$Yaml$Decode$fromValue, decoder, v0);
			}
		}
	});
var myrho$yaml$Yaml$Decode$field = F2(
	function (name, decoder) {
		return function (v) {
			return A3(
				myrho$yaml$Yaml$Decode$find,
				_List_fromArray(
					[name]),
				decoder,
				v);
		};
	});
var myrho$yaml$Yaml$Decode$singleResult = function () {
	var each = F2(
		function (v, r) {
			if (r.$ === 1) {
				return r;
			} else {
				var vs = r.a;
				if (!v.$) {
					var vok = v.a;
					return elm$core$Result$Ok(
						A2(elm$core$List$cons, vok, vs));
				} else {
					var err = v.a;
					return elm$core$Result$Err(err);
				}
			}
		});
	return A2(
		elm$core$Basics$composeR,
		A2(
			elm$core$List$foldl,
			each,
			elm$core$Result$Ok(_List_Nil)),
		elm$core$Result$map(elm$core$List$reverse));
}();
var myrho$yaml$Yaml$Decode$list = function (decoder) {
	return function (v) {
		switch (v.$) {
			case 3:
				var list_ = v.a;
				return myrho$yaml$Yaml$Decode$singleResult(
					A2(
						elm$core$List$map,
						myrho$yaml$Yaml$Decode$fromValue(decoder),
						list_));
			case 6:
				return elm$core$Result$Ok(_List_Nil);
			default:
				return A2(myrho$yaml$Yaml$Decode$decodeError, 'list', v);
		}
	};
};
var myrho$yaml$Yaml$Decode$map8 = F9(
	function (func, _n0, _n1, _n2, _n3, _n4, _n5, _n6, _n7) {
		var a = _n0;
		var b = _n1;
		var c = _n2;
		var d = _n3;
		var e = _n4;
		var f = _n5;
		var g = _n6;
		var h = _n7;
		return function (v0) {
			var _n8 = a(v0);
			if (_n8.$ === 1) {
				var err1 = _n8.a;
				return elm$core$Result$Err(err1);
			} else {
				var av = _n8.a;
				var _n9 = b(v0);
				if (_n9.$ === 1) {
					var err2 = _n9.a;
					return elm$core$Result$Err(err2);
				} else {
					var bv = _n9.a;
					var _n10 = c(v0);
					if (_n10.$ === 1) {
						var err3 = _n10.a;
						return elm$core$Result$Err(err3);
					} else {
						var cv = _n10.a;
						var _n11 = d(v0);
						if (_n11.$ === 1) {
							var err4 = _n11.a;
							return elm$core$Result$Err(err4);
						} else {
							var dv = _n11.a;
							var _n12 = e(v0);
							if (_n12.$ === 1) {
								var err5 = _n12.a;
								return elm$core$Result$Err(err5);
							} else {
								var ev = _n12.a;
								var _n13 = f(v0);
								if (_n13.$ === 1) {
									var err6 = _n13.a;
									return elm$core$Result$Err(err6);
								} else {
									var fv = _n13.a;
									var _n14 = g(v0);
									if (_n14.$ === 1) {
										var err7 = _n14.a;
										return elm$core$Result$Err(err7);
									} else {
										var gv = _n14.a;
										var _n15 = h(v0);
										if (_n15.$ === 1) {
											var err8 = _n15.a;
											return elm$core$Result$Err(err8);
										} else {
											var hv = _n15.a;
											return elm$core$Result$Ok(
												A8(func, av, bv, cv, dv, ev, fv, gv, hv));
										}
									}
								}
							}
						}
					}
				}
			}
		};
	});
var myrho$yaml$Yaml$Decode$maybe = function (decoder) {
	return function (v) {
		var _n0 = A2(myrho$yaml$Yaml$Decode$fromValue, decoder, v);
		if (!_n0.$) {
			var a = _n0.a;
			return elm$core$Result$Ok(
				elm$core$Maybe$Just(a));
		} else {
			return elm$core$Result$Ok(elm$core$Maybe$Nothing);
		}
	};
};
var myrho$yaml$Yaml$Decode$string = function (v) {
	switch (v.$) {
		case 0:
			var string_ = v.a;
			return elm$core$Result$Ok(string_);
		case 6:
			return elm$core$Result$Ok('');
		default:
			return A2(myrho$yaml$Yaml$Decode$decodeError, 'string', v);
	}
};
var author$project$Content$decodeMeta = A9(
	myrho$yaml$Yaml$Decode$map8,
	author$project$Content$Meta,
	A2(myrho$yaml$Yaml$Decode$field, 'title', myrho$yaml$Yaml$Decode$string),
	A2(myrho$yaml$Yaml$Decode$field, 'date', myrho$yaml$Yaml$Decode$string),
	A2(myrho$yaml$Yaml$Decode$field, 'description', myrho$yaml$Yaml$Decode$string),
	A2(myrho$yaml$Yaml$Decode$field, 'resname', myrho$yaml$Yaml$Decode$string),
	A2(
		myrho$yaml$Yaml$Decode$field,
		'tags',
		myrho$yaml$Yaml$Decode$list(myrho$yaml$Yaml$Decode$string)),
	myrho$yaml$Yaml$Decode$maybe(
		A2(myrho$yaml$Yaml$Decode$field, 'status', myrho$yaml$Yaml$Decode$string)),
	A2(myrho$yaml$Yaml$Decode$field, 'slug', myrho$yaml$Yaml$Decode$string),
	myrho$yaml$Yaml$Decode$maybe(
		A2(myrho$yaml$Yaml$Decode$field, 'toc', myrho$yaml$Yaml$Decode$bool)));
var author$project$Content$decodeMetas = myrho$yaml$Yaml$Decode$list(author$project$Content$decodeMeta);
var myrho$yaml$Yaml$Decode$Parsing = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {aC: col, a3: problem, bd: row};
	});
var elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3(elm$parser$Parser$DeadEnd, p.bd, p.aC, p.a3);
};
var elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2(elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2(elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var elm$parser$Parser$Advanced$run = F2(
	function (_n0, src) {
		var parse = _n0;
		var _n1 = parse(
			{aC: 1, c: _List_Nil, d: 1, b: 0, bd: 1, a: src});
		if (!_n1.$) {
			var value = _n1.b;
			return elm$core$Result$Ok(value);
		} else {
			var bag = _n1.b;
			return elm$core$Result$Err(
				A2(elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var elm$parser$Parser$run = F2(
	function (parser, source) {
		var _n0 = A2(elm$parser$Parser$Advanced$run, parser, source);
		if (!_n0.$) {
			var a = _n0.a;
			return elm$core$Result$Ok(a);
		} else {
			var problems = _n0.a;
			return elm$core$Result$Err(
				A2(elm$core$List$map, elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var myrho$yaml$Yaml$Parser$problemToString = function (p) {
	switch (p.$) {
		case 0:
			var msg = p.a;
			return 'Expected ' + msg;
		case 1:
			return 'Expected an integer';
		case 2:
			return 'Expected a hexadecimal value';
		case 3:
			return 'Expected an octal value';
		case 4:
			return 'Expected a binary value';
		case 5:
			return 'Expected a float';
		case 6:
			return 'Expected a number';
		case 7:
			return 'Expected a variable';
		case 8:
			var name = p.a;
			return 'Expected symbol \'' + (name + '\'');
		case 9:
			var name = p.a;
			return 'Expected keyword \'' + (name + '\'');
		case 10:
			return 'Expected end of input';
		case 11:
			return 'Encountered an unexpected character';
		case 12:
			var msg = p.a;
			return 'Problem: ' + msg;
		default:
			return 'Bad repeat';
	}
};
var myrho$yaml$Yaml$Parser$deadEndToString = function (deadend) {
	return 'Line ' + (elm$core$String$fromInt(deadend.bd) + (', column ' + (elm$core$String$fromInt(deadend.aC) + (': ' + myrho$yaml$Yaml$Parser$problemToString(deadend.a3)))));
};
var myrho$yaml$Yaml$Parser$deadEndsToString = function (deadends) {
	return A2(
		elm$core$String$join,
		'\n',
		A2(elm$core$List$map, myrho$yaml$Yaml$Parser$deadEndToString, deadends));
};
var elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var elm$core$Dict$values = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2(elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var myrho$yaml$Yaml$Parser$Ast$fold = F3(
	function (f, value, z) {
		switch (value.$) {
			case 0:
				return A2(f, value, z);
			case 1:
				return A2(f, value, z);
			case 2:
				return A2(f, value, z);
			case 5:
				return A2(f, value, z);
			case 6:
				return A2(f, value, z);
			case 8:
				return A2(f, value, z);
			case 3:
				var l = value.a;
				return A2(
					f,
					value,
					A3(
						elm$core$List$foldl,
						myrho$yaml$Yaml$Parser$Ast$fold(f),
						z,
						l));
			case 4:
				var r = value.a;
				return A2(
					f,
					value,
					A3(
						elm$core$List$foldl,
						myrho$yaml$Yaml$Parser$Ast$fold(f),
						z,
						elm$core$Dict$values(r)));
			default:
				var nm = value.a;
				var a = value.b;
				return A2(
					f,
					value,
					A3(myrho$yaml$Yaml$Parser$Ast$fold, f, a, z));
		}
	});
var elm$core$Dict$fromList = function (assocs) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (_n0, dict) {
				var key = _n0.a;
				var value = _n0.b;
				return A3(elm$core$Dict$insert, key, value, dict);
			}),
		elm$core$Dict$empty,
		assocs);
};
var myrho$yaml$Yaml$Parser$Ast$Anchor_ = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var myrho$yaml$Yaml$Parser$Ast$List_ = function (a) {
	return {$: 3, a: a};
};
var myrho$yaml$Yaml$Parser$Ast$Record_ = function (a) {
	return {$: 4, a: a};
};
var myrho$yaml$Yaml$Parser$Ast$map = F2(
	function (f, value) {
		switch (value.$) {
			case 0:
				return f(value);
			case 1:
				return f(value);
			case 2:
				return f(value);
			case 5:
				return f(value);
			case 6:
				return f(value);
			case 8:
				return f(value);
			case 3:
				var l = value.a;
				return f(
					myrho$yaml$Yaml$Parser$Ast$List_(
						A2(
							elm$core$List$map,
							myrho$yaml$Yaml$Parser$Ast$map(f),
							l)));
			case 4:
				var r = value.a;
				return f(
					myrho$yaml$Yaml$Parser$Ast$Record_(
						elm$core$Dict$fromList(
							A2(
								elm$core$List$map,
								function (_n1) {
									var k = _n1.a;
									var v = _n1.b;
									return _Utils_Tuple2(
										k,
										A2(myrho$yaml$Yaml$Parser$Ast$map, f, v));
								},
								elm$core$Dict$toList(r)))));
			default:
				var name = value.a;
				var a = value.b;
				return f(
					A2(
						myrho$yaml$Yaml$Parser$Ast$Anchor_,
						name,
						A2(myrho$yaml$Yaml$Parser$Ast$map, f, a)));
		}
	});
var myrho$yaml$Yaml$Parser$deref = function (ast) {
	var anchorMap = A3(
		myrho$yaml$Yaml$Parser$Ast$fold,
		F2(
			function (node, d) {
				if (node.$ === 7) {
					var name = node.a;
					var v = node.b;
					return A3(elm$core$Dict$insert, name, v, d);
				} else {
					return d;
				}
			}),
		ast,
		elm$core$Dict$empty);
	var replaceAnchors = function (v) {
		switch (v.$) {
			case 8:
				var name = v.a;
				return A2(
					elm$core$Maybe$withDefault,
					v,
					A2(elm$core$Dict$get, name, anchorMap));
			case 7:
				var node = v.b;
				return node;
			default:
				return v;
		}
	};
	return A2(myrho$yaml$Yaml$Parser$Ast$map, replaceAnchors, ast);
};
var elm$core$Basics$always = F2(
	function (a, _n0) {
		return a;
	});
var elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var elm$parser$Parser$Advanced$Parser = elm$core$Basics$identity;
var elm$parser$Parser$Advanced$map2 = F3(
	function (func, _n0, _n1) {
		var parseA = _n0;
		var parseB = _n1;
		return function (s0) {
			var _n2 = parseA(s0);
			if (_n2.$ === 1) {
				var p = _n2.a;
				var x = _n2.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _n2.a;
				var a = _n2.b;
				var s1 = _n2.c;
				var _n3 = parseB(s1);
				if (_n3.$ === 1) {
					var p2 = _n3.a;
					var x = _n3.b;
					return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _n3.a;
					var b = _n3.b;
					var s2 = _n3.c;
					return A3(
						elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$always, keepParser, ignoreParser);
	});
var elm$parser$Parser$ignorer = elm$parser$Parser$Advanced$ignorer;
var elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$apL, parseFunc, parseArg);
	});
var elm$parser$Parser$keeper = elm$parser$Parser$Advanced$keeper;
var elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3(elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var elm$parser$Parser$succeed = elm$parser$Parser$Advanced$succeed;
var elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _n0) {
		var parseA = _n0;
		return function (s0) {
			var _n1 = parseA(s0);
			if (_n1.$ === 1) {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				var _n2 = callback(a);
				var parseB = _n2;
				var _n3 = parseB(s1);
				if (_n3.$ === 1) {
					var p2 = _n3.a;
					var x = _n3.b;
					return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _n3.a;
					var b = _n3.b;
					var s2 = _n3.c;
					return A3(elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var elm$parser$Parser$andThen = elm$parser$Parser$Advanced$andThen;
var elm$parser$Parser$Advanced$getCol = function (s) {
	return A3(elm$parser$Parser$Advanced$Good, false, s.aC, s);
};
var elm$parser$Parser$getCol = elm$parser$Parser$Advanced$getCol;
var elm$parser$Parser$Advanced$Empty = {$: 0};
var elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2(elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _n1 = parse(s0);
				if (!_n1.$) {
					var step = _n1;
					return step;
				} else {
					var step = _n1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2(elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3(elm$parser$Parser$Advanced$oneOfHelp, s, elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var elm$parser$Parser$oneOf = elm$parser$Parser$Advanced$oneOf;
var elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return elm$core$Maybe$Just(x);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$Advanced$backtrackable = function (_n0) {
	var parse = _n0;
	return function (s0) {
		var _n1 = parse(s0);
		if (_n1.$ === 1) {
			var x = _n1.b;
			return A2(elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _n1.b;
			var s1 = _n1.c;
			return A3(elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var elm$parser$Parser$backtrackable = elm$parser$Parser$Advanced$backtrackable;
var elm$parser$Parser$UnexpectedChar = {$: 11};
var elm$core$Basics$negate = function (n) {
	return -n;
};
var elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {aC: col, bC: contextStack, a3: problem, bd: row};
	});
var elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			elm$parser$Parser$Advanced$AddRight,
			elm$parser$Parser$Advanced$Empty,
			A4(elm$parser$Parser$Advanced$DeadEnd, s.bd, s.aC, x, s.c));
	});
var elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				elm$parser$Parser$Advanced$Bad,
				false,
				A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				elm$parser$Parser$Advanced$Good,
				true,
				0,
				{aC: 1, c: s.c, d: s.d, b: s.b + 1, bd: s.bd + 1, a: s.a}) : A3(
				elm$parser$Parser$Advanced$Good,
				true,
				0,
				{aC: s.aC + 1, c: s.c, d: s.d, b: newOffset, bd: s.bd, a: s.a}));
		};
	});
var elm$parser$Parser$chompIf = function (isGood) {
	return A2(elm$parser$Parser$Advanced$chompIf, isGood, elm$parser$Parser$UnexpectedChar);
};
var elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{aC: col, c: s0.c, d: s0.d, b: offset, bd: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5(elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.bd, s.aC, s);
	};
};
var elm$parser$Parser$chompWhile = elm$parser$Parser$Advanced$chompWhile;
var elm$parser$Parser$ExpectingEnd = {$: 10};
var elm$core$String$length = _String_length;
var elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			elm$core$String$length(s.a),
			s.b) ? A3(elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var elm$parser$Parser$end = elm$parser$Parser$Advanced$end(elm$parser$Parser$ExpectingEnd);
var elm$core$String$slice = _String_slice;
var elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _n0) {
		var parse = _n0;
		return function (s0) {
			var _n1 = parse(s0);
			if (_n1.$ === 1) {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				return A3(
					elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3(elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2(elm$parser$Parser$Advanced$mapChompedString, elm$core$Basics$always, parser);
};
var elm$parser$Parser$getChompedString = elm$parser$Parser$Advanced$getChompedString;
var elm$parser$Parser$Advanced$map = F2(
	function (func, _n0) {
		var parse = _n0;
		return function (s0) {
			var _n1 = parse(s0);
			if (!_n1.$) {
				var p = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				return A3(
					elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var elm$parser$Parser$map = elm$parser$Parser$Advanced$map;
var elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return elm$parser$Parser$Advanced$Done(a);
	}
};
var elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _n0 = callback(state);
			var parse = _n0;
			var _n1 = parse(s0);
			if (!_n1.$) {
				var p1 = _n1.a;
				var step = _n1.b;
				var s1 = _n1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3(elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4(elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					elm$parser$Parser$map,
					elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var elm$parser$Parser$problem = function (msg) {
	return elm$parser$Parser$Advanced$problem(
		elm$parser$Parser$Problem(msg));
};
var elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$parser$Parser$toToken = function (str) {
	return A2(
		elm$parser$Parser$Advanced$Token,
		str,
		elm$parser$Parser$Expecting(str));
};
var elm$core$Basics$not = _Basics_not;
var elm$core$String$isEmpty = function (string) {
	return string === '';
};
var elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var elm$parser$Parser$Advanced$token = function (_n0) {
	var str = _n0.a;
	var expecting = _n0.b;
	var progress = !elm$core$String$isEmpty(str);
	return function (s) {
		var _n1 = A5(elm$parser$Parser$Advanced$isSubString, str, s.b, s.bd, s.aC, s.a);
		var newOffset = _n1.a;
		var newRow = _n1.b;
		var newCol = _n1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{aC: newCol, c: s.c, d: s.d, b: newOffset, bd: newRow, a: s.a});
	};
};
var elm$parser$Parser$token = function (str) {
	return elm$parser$Parser$Advanced$token(
		elm$parser$Parser$toToken(str));
};
var elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var elm$parser$Parser$Advanced$symbol = elm$parser$Parser$Advanced$token;
var elm$parser$Parser$symbol = function (str) {
	return elm$parser$Parser$Advanced$symbol(
		A2(
			elm$parser$Parser$Advanced$Token,
			str,
			elm$parser$Parser$ExpectingSymbol(str)));
};
var elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var myrho$yaml$Yaml$Parser$refName = A2(
	elm$parser$Parser$keeper,
	elm$parser$Parser$succeed(elm$core$Basics$identity),
	elm$parser$Parser$getChompedString(
		elm$parser$Parser$chompWhile(
			function (c) {
				return !A2(
					elm$core$List$member,
					c,
					_List_fromArray(
						['\u000d', '\n', ' ', '\t', ',', '[', ']', '{', '}']));
			})));
var elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _n0 = A5(_Parser_findSubString, str, s.b, s.bd, s.aC, s.a);
		var newOffset = _n0.a;
		var newRow = _n0.b;
		var newCol = _n0.c;
		var adjustedOffset = (newOffset < 0) ? elm$core$String$length(s.a) : newOffset;
		return A3(
			elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.b, adjustedOffset) < 0,
			0,
			{aC: newCol, c: s.c, d: s.d, b: adjustedOffset, bd: newRow, a: s.a});
	};
};
var elm$parser$Parser$Advanced$lineComment = function (start) {
	return A2(
		elm$parser$Parser$Advanced$ignorer,
		elm$parser$Parser$Advanced$token(start),
		elm$parser$Parser$Advanced$chompUntilEndOr('\n'));
};
var elm$parser$Parser$lineComment = function (str) {
	return elm$parser$Parser$Advanced$lineComment(
		elm$parser$Parser$toToken(str));
};
var myrho$yaml$Yaml$Parser$Util$comment = elm$parser$Parser$lineComment('#');
var myrho$yaml$Yaml$Parser$Util$whitespace = function () {
	var step = function (_n0) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						elm$parser$Parser$Loop(0)),
					myrho$yaml$Yaml$Parser$Util$comment),
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						elm$parser$Parser$Loop(0)),
					elm$parser$Parser$symbol(' ')),
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						elm$parser$Parser$Loop(0)),
					elm$parser$Parser$symbol('\n')),
					elm$parser$Parser$succeed(
					elm$parser$Parser$Done(0))
				]));
	};
	return A2(elm$parser$Parser$loop, 0, step);
}();
var myrho$yaml$Yaml$Parser$anchor = function (valParser) {
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Anchor_),
				elm$parser$Parser$symbol('&')),
			A2(elm$parser$Parser$ignorer, myrho$yaml$Yaml$Parser$refName, myrho$yaml$Yaml$Parser$Util$whitespace)),
		A2(elm$parser$Parser$andThen, valParser, elm$parser$Parser$getCol));
};
var elm$core$Set$Set_elm_builtin = elm$core$Basics$identity;
var elm$core$Set$empty = elm$core$Dict$empty;
var elm$core$Set$insert = F2(
	function (key, _n0) {
		var dict = _n0;
		return A3(elm$core$Dict$insert, key, 0, dict);
	});
var elm$core$Dict$member = F2(
	function (key, dict) {
		var _n0 = A2(elm$core$Dict$get, key, dict);
		if (!_n0.$) {
			return true;
		} else {
			return false;
		}
	});
var elm$core$Set$member = F2(
	function (key, _n0) {
		var dict = _n0;
		return A2(elm$core$Dict$member, key, dict);
	});
var elm$core$Tuple$second = function (_n0) {
	var y = _n0.b;
	return y;
};
var myrho$yaml$Yaml$Parser$duplicatedPropertyKeys = function (properties) {
	var keys = A2(elm$core$List$map, elm$core$Tuple$first, properties);
	var duplicated = A3(
		elm$core$List$foldr,
		F2(
			function (x, _n0) {
				var obs = _n0.a;
				var dup = _n0.b;
				return A2(elm$core$Set$member, x, obs) ? _Utils_Tuple2(
					obs,
					A2(elm$core$Set$insert, x, dup)) : _Utils_Tuple2(
					A2(elm$core$Set$insert, x, obs),
					dup);
			}),
		_Utils_Tuple2(elm$core$Set$empty, elm$core$Set$empty),
		keys);
	return elm$core$Set$toList(duplicated.b);
};
var myrho$yaml$Yaml$Parser$duplicatedPropertyKeysCheck = function (properties) {
	var duplicates = myrho$yaml$Yaml$Parser$duplicatedPropertyKeys(properties);
	return (!elm$core$List$length(duplicates)) ? elm$parser$Parser$succeed(properties) : elm$parser$Parser$problem(
		'Non-unique keys in record: ' + A2(elm$core$String$join, ', ', duplicates));
};
var myrho$yaml$Yaml$Parser$listElementBegin = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			elm$parser$Parser$symbol('- '),
			elm$parser$Parser$symbol('-\n')
		]));
var myrho$yaml$Yaml$Parser$listInlineOnDone = F2(
	function (elements, element) {
		return elm$parser$Parser$Done(
			elm$core$List$reverse(
				A2(elm$core$List$cons, element, elements)));
	});
var myrho$yaml$Yaml$Parser$listInlineOnMore = F2(
	function (elements, element) {
		return elm$parser$Parser$Loop(
			A2(elm$core$List$cons, element, elements));
	});
var myrho$yaml$Yaml$Parser$Util$is = F2(
	function (searched, _char) {
		return _Utils_eq(_char, searched);
	});
var myrho$yaml$Yaml$Parser$Util$isComma = myrho$yaml$Yaml$Parser$Util$is(',');
var myrho$yaml$Yaml$Parser$Util$isListEnd = myrho$yaml$Yaml$Parser$Util$is(']');
var myrho$yaml$Yaml$Parser$listInlineNext = F2(
	function (elements, element) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A2(myrho$yaml$Yaml$Parser$listInlineOnMore, elements, element)),
					elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isComma)),
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A2(myrho$yaml$Yaml$Parser$listInlineOnDone, elements, element)),
					elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isListEnd))
				]));
	});
var elm$core$String$toFloat = _String_toFloat;
var elm$core$String$toInt = _String_toInt;
var elm$core$String$toLower = _String_toLower;
var elm$core$String$trim = _String_trim;
var myrho$yaml$Yaml$Parser$Ast$Bool_ = function (a) {
	return {$: 5, a: a};
};
var myrho$yaml$Yaml$Parser$Ast$Float_ = function (a) {
	return {$: 1, a: a};
};
var myrho$yaml$Yaml$Parser$Ast$Int_ = function (a) {
	return {$: 2, a: a};
};
var myrho$yaml$Yaml$Parser$Ast$Null_ = {$: 6};
var myrho$yaml$Yaml$Parser$Ast$String_ = function (a) {
	return {$: 0, a: a};
};
var myrho$yaml$Yaml$Parser$Ast$fromString = function (string) {
	var trimmed = elm$core$String$trim(string);
	var _n0 = elm$core$String$toLower(trimmed);
	switch (_n0) {
		case '':
			return myrho$yaml$Yaml$Parser$Ast$Null_;
		case 'null':
			return myrho$yaml$Yaml$Parser$Ast$Null_;
		case 'true':
			return myrho$yaml$Yaml$Parser$Ast$Bool_(true);
		case 'false':
			return myrho$yaml$Yaml$Parser$Ast$Bool_(false);
		default:
			var other = _n0;
			var _n1 = elm$core$String$toInt(other);
			if (!_n1.$) {
				var _int = _n1.a;
				return myrho$yaml$Yaml$Parser$Ast$Int_(_int);
			} else {
				var _n2 = elm$core$String$toFloat(other);
				if (!_n2.$) {
					var _float = _n2.a;
					return myrho$yaml$Yaml$Parser$Ast$Float_(_float);
				} else {
					return myrho$yaml$Yaml$Parser$Ast$String_(trimmed);
				}
			}
	}
};
var myrho$yaml$Yaml$Parser$Util$neither = F3(
	function (f1, f2, _char) {
		return (!f1(_char)) && (!f2(_char));
	});
var myrho$yaml$Yaml$Parser$listInlineString = A2(
	elm$parser$Parser$map,
	myrho$yaml$Yaml$Parser$Ast$fromString,
	elm$parser$Parser$getChompedString(
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(0),
			elm$parser$Parser$chompWhile(
				A2(myrho$yaml$Yaml$Parser$Util$neither, myrho$yaml$Yaml$Parser$Util$isComma, myrho$yaml$Yaml$Parser$Util$isListEnd)))));
var myrho$yaml$Yaml$Parser$recordInlineOnDone = F2(
	function (elements, element) {
		return elm$parser$Parser$Done(
			elm$core$List$reverse(
				A2(elm$core$List$cons, element, elements)));
	});
var myrho$yaml$Yaml$Parser$recordInlineOnMore = F2(
	function (elements, element) {
		return elm$parser$Parser$Loop(
			A2(elm$core$List$cons, element, elements));
	});
var myrho$yaml$Yaml$Parser$Util$isRecordEnd = myrho$yaml$Yaml$Parser$Util$is('}');
var myrho$yaml$Yaml$Parser$recordInlineNext = F2(
	function (elements, element) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A2(myrho$yaml$Yaml$Parser$recordInlineOnMore, elements, element)),
					elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isComma)),
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A2(myrho$yaml$Yaml$Parser$recordInlineOnDone, elements, element)),
					elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isRecordEnd))
				]));
	});
var myrho$yaml$Yaml$Parser$Util$isColon = myrho$yaml$Yaml$Parser$Util$is(':');
var myrho$yaml$Yaml$Parser$Util$neither3 = F4(
	function (f1, f2, f3, _char) {
		return (!f1(_char)) && ((!f2(_char)) && (!f3(_char)));
	});
var myrho$yaml$Yaml$Parser$recordInlinePropertyNameString = A2(
	elm$parser$Parser$map,
	elm$core$String$trim,
	elm$parser$Parser$getChompedString(
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(0),
				elm$parser$Parser$chompWhile(
					A3(myrho$yaml$Yaml$Parser$Util$neither3, myrho$yaml$Yaml$Parser$Util$isColon, myrho$yaml$Yaml$Parser$Util$isComma, myrho$yaml$Yaml$Parser$Util$isRecordEnd))),
			myrho$yaml$Yaml$Parser$Util$whitespace)));
var elm$core$Basics$neq = _Utils_notEqual;
var elm$core$String$cons = _String_cons;
var elm$core$String$fromChar = function (_char) {
	return A2(elm$core$String$cons, _char, '');
};
var elm$core$String$fromList = _String_fromList;
var myrho$elm_parser_extras$Parser$Extras$quotedStringHelp = F3(
	function (escape, quote, string) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$map,
					function (_n0) {
						return elm$parser$Parser$Loop(
							_Utils_ap(
								string,
								elm$core$String$fromChar(quote)));
					},
					elm$parser$Parser$token(
						elm$core$String$fromList(
							_List_fromArray(
								[escape, quote])))),
					A2(
					elm$parser$Parser$map,
					function (_n1) {
						return elm$parser$Parser$Loop(
							_Utils_ap(
								string,
								elm$core$String$fromChar(escape)));
					},
					elm$parser$Parser$token(
						elm$core$String$fromList(
							_List_fromArray(
								[escape, escape])))),
					A2(
					elm$parser$Parser$map,
					function (_n2) {
						return elm$parser$Parser$Done(string);
					},
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq(quote))),
					A2(
					elm$parser$Parser$map,
					function (_n3) {
						return elm$parser$Parser$Loop(
							_Utils_ap(
								string,
								elm$core$String$fromChar(escape)));
					},
					elm$parser$Parser$chompIf(
						elm$core$Basics$eq(escape))),
					A2(
					elm$parser$Parser$map,
					function (s) {
						return elm$parser$Parser$Loop(
							_Utils_ap(string, s));
					},
					elm$parser$Parser$getChompedString(
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(0),
							elm$parser$Parser$chompWhile(
								function (c) {
									return (!_Utils_eq(c, quote)) && (!_Utils_eq(c, escape));
								}))))
				]));
	});
var myrho$elm_parser_extras$Parser$Extras$quotedString = F2(
	function (escape, quote) {
		return A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(elm$core$Basics$identity),
				elm$parser$Parser$chompIf(
					elm$core$Basics$eq(quote))),
			A2(
				elm$parser$Parser$loop,
				'',
				A2(myrho$elm_parser_extras$Parser$Extras$quotedStringHelp, escape, quote)));
	});
var myrho$yaml$Yaml$Parser$Util$doubleQuotes = A2(myrho$elm_parser_extras$Parser$Extras$quotedString, '\\', '\"');
var myrho$yaml$Yaml$Parser$Util$isNewLine = myrho$yaml$Yaml$Parser$Util$is('\n');
var myrho$yaml$Yaml$Parser$Util$isSpace = myrho$yaml$Yaml$Parser$Util$is(' ');
var myrho$yaml$Yaml$Parser$Util$singleQuotes = A2(myrho$elm_parser_extras$Parser$Extras$quotedString, '\'', '\'');
var myrho$yaml$Yaml$Parser$recordInlinePropertyName = A2(
	elm$parser$Parser$keeper,
	elm$parser$Parser$succeed(elm$core$Basics$identity),
	A2(
		elm$parser$Parser$ignorer,
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$oneOf(
					_List_fromArray(
						[myrho$yaml$Yaml$Parser$Util$singleQuotes, myrho$yaml$Yaml$Parser$Util$doubleQuotes, myrho$yaml$Yaml$Parser$recordInlinePropertyNameString])),
				elm$parser$Parser$chompWhile(myrho$yaml$Yaml$Parser$Util$isSpace)),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isColon),
						elm$parser$Parser$problem('I was parsing an inline record, when I ran into an invalid property. It is missing the \":\"!')
					]))),
		elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isNewLine),
					elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isSpace),
					elm$parser$Parser$problem('I was parsing an inline record, but missing a space or a new line between the \":\" and the value!')
				]))));
var myrho$yaml$Yaml$Parser$recordInlineString = A2(
	elm$parser$Parser$map,
	myrho$yaml$Yaml$Parser$Ast$fromString,
	elm$parser$Parser$getChompedString(
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(0),
			elm$parser$Parser$chompWhile(
				A2(myrho$yaml$Yaml$Parser$Util$neither, myrho$yaml$Yaml$Parser$Util$isComma, myrho$yaml$Yaml$Parser$Util$isRecordEnd)))));
var myrho$yaml$Yaml$Parser$Ast$Alias_ = function (a) {
	return {$: 8, a: a};
};
var myrho$yaml$Yaml$Parser$reference = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Alias_),
		elm$parser$Parser$symbol('*')),
	myrho$yaml$Yaml$Parser$refName);
var myrho$yaml$Yaml$Parser$Util$indented = F2(
	function (indent, next) {
		var check = function (actual) {
			return elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$andThen,
						function (_n0) {
							return next.af;
						},
						elm$parser$Parser$end),
						A2(
						elm$parser$Parser$andThen,
						function (_n1) {
							return next.af;
						},
						elm$parser$Parser$symbol('\n...\n')),
						_Utils_eq(actual, indent) ? next.ag : ((_Utils_cmp(actual, indent) > 0) ? next.ah(actual) : next.al)
					]));
		};
		return A2(
			elm$parser$Parser$andThen,
			check,
			A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Basics$identity),
					myrho$yaml$Yaml$Parser$Util$whitespace),
				elm$parser$Parser$getCol));
	});
var myrho$yaml$Yaml$Parser$Util$isListStart = myrho$yaml$Yaml$Parser$Util$is('[');
var myrho$yaml$Yaml$Parser$Util$isRecordStart = myrho$yaml$Yaml$Parser$Util$is('{');
var elm$core$String$concat = function (strings) {
	return A2(elm$core$String$join, '', strings);
};
var myrho$yaml$Yaml$Parser$Util$characters = function (isOk) {
	var more = F2(
		function (chars, _char) {
			return elm$parser$Parser$Loop(
				A2(elm$core$List$cons, _char, chars));
		});
	var done = function (chars) {
		return elm$parser$Parser$Done(
			elm$core$String$concat(
				elm$core$List$reverse(chars)));
	};
	var step = function (chars) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						done(chars)),
					myrho$yaml$Yaml$Parser$Util$comment),
					A2(
					elm$parser$Parser$map,
					more(chars),
					elm$parser$Parser$getChompedString(
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(0),
							elm$parser$Parser$chompIf(isOk)))),
					elm$parser$Parser$succeed(
					done(chars))
				]));
	};
	return A2(elm$parser$Parser$loop, _List_Nil, step);
};
var myrho$yaml$Yaml$Parser$Util$spaces = elm$parser$Parser$chompWhile(myrho$yaml$Yaml$Parser$Util$isSpace);
var myrho$yaml$Yaml$Parser$Util$multilineStep = F2(
	function (indent, lines) {
		var multilineString = function (lines_) {
			return A2(
				elm$core$String$join,
				' ',
				elm$core$List$reverse(lines_));
		};
		var conclusion = F2(
			function (line, indent_) {
				return (_Utils_cmp(indent_, indent) > 0) ? elm$parser$Parser$Loop(
					A2(elm$core$List$cons, line, lines)) : elm$parser$Parser$Done(
					multilineString(
						A2(elm$core$List$cons, line, lines)));
			});
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$keeper,
						elm$parser$Parser$succeed(conclusion),
						A2(
							elm$parser$Parser$ignorer,
							A2(
								elm$parser$Parser$ignorer,
								myrho$yaml$Yaml$Parser$Util$characters(
									A2(elm$core$Basics$composeL, elm$core$Basics$not, myrho$yaml$Yaml$Parser$Util$isNewLine)),
								elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isNewLine)),
							myrho$yaml$Yaml$Parser$Util$spaces)),
					elm$parser$Parser$getCol),
					elm$parser$Parser$succeed(
					elm$parser$Parser$Done(
						multilineString(lines)))
				]));
	});
var myrho$yaml$Yaml$Parser$Util$multiline = function (indent) {
	return A2(
		elm$parser$Parser$loop,
		_List_Nil,
		myrho$yaml$Yaml$Parser$Util$multilineStep(indent));
};
var elm$core$String$contains = _String_contains;
var elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {bO: index, bS: match, bW: number, b4: submatches};
	});
var elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var elm$regex$Regex$fromString = function (string) {
	return A2(
		elm$regex$Regex$fromStringWith,
		{aA: false, a_: false},
		string);
};
var elm$regex$Regex$never = _Regex_never;
var elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var myrho$yaml$Yaml$Parser$Util$postProcessString = function (str) {
	var regexFromString = A2(
		elm$core$Basics$composeR,
		elm$regex$Regex$fromString,
		elm$core$Maybe$withDefault(elm$regex$Regex$never));
	return A3(
		elm$regex$Regex$replace,
		regexFromString('\\s\\s+'),
		function (match) {
			return A2(elm$core$String$contains, '\n\n', match.bS) ? '\n' : ' ';
		},
		str);
};
var elm$parser$Parser$chompUntilEndOr = elm$parser$Parser$Advanced$chompUntilEndOr;
var myrho$yaml$Yaml$Parser$Util$remaining = elm$parser$Parser$getChompedString(
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(0),
		elm$parser$Parser$chompUntilEndOr('\n...\n')));
var myrho$yaml$Yaml$Parser$list = function (indent) {
	var confirmed = function (value_) {
		return A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$List_),
			A2(
				elm$parser$Parser$loop,
				_List_fromArray(
					[value_]),
				myrho$yaml$Yaml$Parser$listStep(indent)));
	};
	return A2(
		elm$parser$Parser$andThen,
		confirmed,
		myrho$yaml$Yaml$Parser$listElement(indent));
};
var myrho$yaml$Yaml$Parser$listElement = function (indent) {
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			myrho$yaml$Yaml$Parser$listElementBegin),
		myrho$yaml$Yaml$Parser$listElementValue(indent));
};
var myrho$yaml$Yaml$Parser$listElementValue = function (indent) {
	var elVal = function (indent_) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					myrho$yaml$Yaml$Parser$cyclic$listInline(),
					myrho$yaml$Yaml$Parser$cyclic$recordInline(),
					myrho$yaml$Yaml$Parser$list(indent_),
					A2(myrho$yaml$Yaml$Parser$recordOrString, indent, indent_)
				]));
	};
	return A2(
		myrho$yaml$Yaml$Parser$Util$indented,
		indent,
		{
			af: elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Null_),
			ag: elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Null_),
			ah: function (indent_) {
				return elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							myrho$yaml$Yaml$Parser$anchor(elVal),
							myrho$yaml$Yaml$Parser$reference,
							elVal(indent_)
						]));
			},
			al: elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Null_)
		});
};
var myrho$yaml$Yaml$Parser$listInlineStep = function (elements) {
	return A2(
		elm$parser$Parser$andThen,
		myrho$yaml$Yaml$Parser$listInlineNext(elements),
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(elm$core$Basics$identity),
				myrho$yaml$Yaml$Parser$Util$whitespace),
			A2(
				elm$parser$Parser$ignorer,
				myrho$yaml$Yaml$Parser$cyclic$listInlineValue(),
				myrho$yaml$Yaml$Parser$Util$whitespace)));
};
var myrho$yaml$Yaml$Parser$listStep = F2(
	function (indent, values) {
		var next = function (value_) {
			return elm$parser$Parser$Loop(
				A2(elm$core$List$cons, value_, values));
		};
		var finish = elm$parser$Parser$Done(
			elm$core$List$reverse(values));
		return A2(
			myrho$yaml$Yaml$Parser$Util$indented,
			indent,
			{
				af: elm$parser$Parser$succeed(finish),
				ag: elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							elm$parser$Parser$keeper,
							elm$parser$Parser$succeed(next),
							myrho$yaml$Yaml$Parser$listElement(indent)),
							elm$parser$Parser$succeed(finish)
						])),
				ah: function (_n1) {
					return elm$parser$Parser$problem('I was looking for the next element but didn\'t find one.');
				},
				al: elm$parser$Parser$succeed(finish)
			});
	});
var myrho$yaml$Yaml$Parser$quotedString = function (indent) {
	var withQuote = function (quote) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(myrho$yaml$Yaml$Parser$recordProperty, indent, quote),
					elm$parser$Parser$succeed(
					myrho$yaml$Yaml$Parser$Ast$String_(
						myrho$yaml$Yaml$Parser$Util$postProcessString(quote)))
				]));
	};
	return A2(
		elm$parser$Parser$andThen,
		withQuote,
		A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$oneOf(
					_List_fromArray(
						[myrho$yaml$Yaml$Parser$Util$singleQuotes, myrho$yaml$Yaml$Parser$Util$doubleQuotes])),
				myrho$yaml$Yaml$Parser$Util$spaces)));
};
var myrho$yaml$Yaml$Parser$record = F2(
	function (indent, property) {
		var confirmed = function (value_) {
			return A2(
				elm$parser$Parser$map,
				A2(elm$core$Basics$composeL, myrho$yaml$Yaml$Parser$Ast$Record_, elm$core$Dict$fromList),
				A2(
					elm$parser$Parser$andThen,
					myrho$yaml$Yaml$Parser$duplicatedPropertyKeysCheck,
					A2(
						elm$parser$Parser$keeper,
						elm$parser$Parser$succeed(elm$core$Basics$identity),
						A2(
							elm$parser$Parser$loop,
							_List_fromArray(
								[
									_Utils_Tuple2(property, value_)
								]),
							myrho$yaml$Yaml$Parser$recordStep(indent)))));
		};
		return A2(
			elm$parser$Parser$andThen,
			confirmed,
			myrho$yaml$Yaml$Parser$recordElementValue(indent));
	});
var myrho$yaml$Yaml$Parser$recordElement = function (indent) {
	var property = elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				myrho$yaml$Yaml$Parser$Util$singleQuotes,
				myrho$yaml$Yaml$Parser$Util$doubleQuotes,
				elm$parser$Parser$getChompedString(
				elm$parser$Parser$chompWhile(
					A2(myrho$yaml$Yaml$Parser$Util$neither, myrho$yaml$Yaml$Parser$Util$isColon, myrho$yaml$Yaml$Parser$Util$isNewLine)))
			]));
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Tuple$pair),
			A2(
				elm$parser$Parser$ignorer,
				A2(elm$parser$Parser$ignorer, property, myrho$yaml$Yaml$Parser$Util$spaces),
				elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isColon))),
		myrho$yaml$Yaml$Parser$recordElementValue(indent));
};
var myrho$yaml$Yaml$Parser$recordElementValue = function (indent) {
	var elVal = function (indent_) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					myrho$yaml$Yaml$Parser$cyclic$listInline(),
					myrho$yaml$Yaml$Parser$cyclic$recordInline(),
					myrho$yaml$Yaml$Parser$list(indent_),
					A2(myrho$yaml$Yaml$Parser$recordOrString, indent, indent_)
				]));
	};
	return A2(
		myrho$yaml$Yaml$Parser$Util$indented,
		indent,
		{
			af: elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Null_),
			ag: elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						myrho$yaml$Yaml$Parser$list(indent),
						elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Null_)
					])),
			ah: function (indent_) {
				return elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							myrho$yaml$Yaml$Parser$anchor(elVal),
							myrho$yaml$Yaml$Parser$reference,
							elVal(indent_)
						]));
			},
			al: elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Null_)
		});
};
var myrho$yaml$Yaml$Parser$recordInlineStep = function (elements) {
	return A2(
		elm$parser$Parser$andThen,
		myrho$yaml$Yaml$Parser$recordInlineNext(elements),
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(elm$core$Basics$identity),
				myrho$yaml$Yaml$Parser$Util$whitespace),
			A2(
				elm$parser$Parser$ignorer,
				myrho$yaml$Yaml$Parser$cyclic$recordInlineValue(),
				myrho$yaml$Yaml$Parser$Util$whitespace)));
};
var myrho$yaml$Yaml$Parser$recordOrString = F2(
	function (indent, indent_) {
		var removeComment = function (string) {
			return A2(
				elm$core$Maybe$withDefault,
				'',
				elm$core$List$head(
					A2(elm$core$String$split, '#', string)));
		};
		var addRemaining = F2(
			function (string, remaining) {
				return myrho$yaml$Yaml$Parser$Ast$fromString(
					myrho$yaml$Yaml$Parser$Util$postProcessString(
						_Utils_ap(
							removeComment(string),
							remaining)));
			});
		var withString = function (string) {
			return elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(
							myrho$yaml$Yaml$Parser$Ast$fromString(string)),
						elm$parser$Parser$end),
						A2(myrho$yaml$Yaml$Parser$recordProperty, indent_, string),
						A2(
						elm$parser$Parser$keeper,
						elm$parser$Parser$succeed(
							addRemaining(string)),
						(!indent) ? myrho$yaml$Yaml$Parser$Util$remaining : myrho$yaml$Yaml$Parser$Util$multiline(indent))
					]));
		};
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					myrho$yaml$Yaml$Parser$quotedString(indent_),
					A2(
					elm$parser$Parser$andThen,
					withString,
					elm$parser$Parser$getChompedString(
						A2(
							elm$parser$Parser$ignorer,
							A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$succeed(elm$core$Basics$identity),
								elm$parser$Parser$chompIf(
									A2(myrho$yaml$Yaml$Parser$Util$neither, myrho$yaml$Yaml$Parser$Util$isColon, myrho$yaml$Yaml$Parser$Util$isNewLine))),
							elm$parser$Parser$chompWhile(
								A2(myrho$yaml$Yaml$Parser$Util$neither, myrho$yaml$Yaml$Parser$Util$isColon, myrho$yaml$Yaml$Parser$Util$isNewLine))))),
					A2(
					elm$parser$Parser$andThen,
					withString,
					elm$parser$Parser$getChompedString(
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(elm$core$Basics$identity),
							elm$parser$Parser$chompWhile(myrho$yaml$Yaml$Parser$Util$isColon))))
				]));
	});
var myrho$yaml$Yaml$Parser$recordProperty = F2(
	function (indent, name) {
		return A2(
			elm$parser$Parser$andThen,
			elm$core$Basics$identity,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(
					A2(myrho$yaml$Yaml$Parser$record, indent, name)),
				elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							elm$parser$Parser$token(': '),
							elm$parser$Parser$token(':\n'),
							A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$backtrackable(
								elm$parser$Parser$token(':')),
							elm$parser$Parser$end)
						]))));
	});
var myrho$yaml$Yaml$Parser$recordStep = F2(
	function (indent, values) {
		var next = function (value_) {
			return elm$parser$Parser$Loop(
				A2(elm$core$List$cons, value_, values));
		};
		var finish = elm$parser$Parser$Done(
			elm$core$List$reverse(values));
		return A2(
			myrho$yaml$Yaml$Parser$Util$indented,
			indent,
			{
				af: elm$parser$Parser$succeed(finish),
				ag: A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(next),
					myrho$yaml$Yaml$Parser$recordElement(indent)),
				ah: function (_n0) {
					return elm$parser$Parser$problem('I was looking for the next property but didn\'t find one.');
				},
				al: elm$parser$Parser$succeed(finish)
			});
	});
function myrho$yaml$Yaml$Parser$cyclic$recordInlineValue() {
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Tuple$pair),
			A2(elm$parser$Parser$ignorer, myrho$yaml$Yaml$Parser$recordInlinePropertyName, myrho$yaml$Yaml$Parser$Util$whitespace)),
		myrho$yaml$Yaml$Parser$cyclic$recordInlinePropertyValue());
}
function myrho$yaml$Yaml$Parser$cyclic$recordInlinePropertyValue() {
	var propVal = elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				myrho$yaml$Yaml$Parser$cyclic$listInline(),
				myrho$yaml$Yaml$Parser$cyclic$recordInline(),
				myrho$yaml$Yaml$Parser$recordInlineString
			]));
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				myrho$yaml$Yaml$Parser$anchor(
				elm$core$Basics$always(propVal)),
				myrho$yaml$Yaml$Parser$reference,
				propVal
			]));
}
function myrho$yaml$Yaml$Parser$cyclic$listInlineValue() {
	var inlineVal = elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				myrho$yaml$Yaml$Parser$cyclic$listInline(),
				myrho$yaml$Yaml$Parser$cyclic$recordInline(),
				myrho$yaml$Yaml$Parser$quotedString(0),
				myrho$yaml$Yaml$Parser$listInlineString
			]));
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				myrho$yaml$Yaml$Parser$anchor(
				elm$core$Basics$always(inlineVal)),
				myrho$yaml$Yaml$Parser$reference,
				inlineVal
			]));
}
function myrho$yaml$Yaml$Parser$cyclic$listInline() {
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$List_),
				elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isListStart)),
			myrho$yaml$Yaml$Parser$Util$whitespace),
		myrho$yaml$Yaml$Parser$cyclic$listInlineStepOne());
}
function myrho$yaml$Yaml$Parser$cyclic$listInlineStepOne() {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(_List_Nil),
				elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isListEnd)),
				A2(
				elm$parser$Parser$keeper,
				elm$parser$Parser$succeed(elm$core$Basics$identity),
				A2(elm$parser$Parser$loop, _List_Nil, myrho$yaml$Yaml$Parser$listInlineStep))
			]));
}
function myrho$yaml$Yaml$Parser$cyclic$recordInline() {
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(
					A2(elm$core$Basics$composeL, myrho$yaml$Yaml$Parser$Ast$Record_, elm$core$Dict$fromList)),
				elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isRecordStart)),
			myrho$yaml$Yaml$Parser$Util$whitespace),
		myrho$yaml$Yaml$Parser$cyclic$recordInlineStepOne());
}
function myrho$yaml$Yaml$Parser$cyclic$recordInlineStepOne() {
	return A2(
		elm$parser$Parser$andThen,
		myrho$yaml$Yaml$Parser$duplicatedPropertyKeysCheck,
		elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(_List_Nil),
					elm$parser$Parser$chompIf(myrho$yaml$Yaml$Parser$Util$isRecordEnd)),
					A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(elm$core$Basics$identity),
					A2(elm$parser$Parser$loop, _List_Nil, myrho$yaml$Yaml$Parser$recordInlineStep))
				])));
}
var myrho$yaml$Yaml$Parser$recordInlineValue = myrho$yaml$Yaml$Parser$cyclic$recordInlineValue();
myrho$yaml$Yaml$Parser$cyclic$recordInlineValue = function () {
	return myrho$yaml$Yaml$Parser$recordInlineValue;
};
var myrho$yaml$Yaml$Parser$recordInlinePropertyValue = myrho$yaml$Yaml$Parser$cyclic$recordInlinePropertyValue();
myrho$yaml$Yaml$Parser$cyclic$recordInlinePropertyValue = function () {
	return myrho$yaml$Yaml$Parser$recordInlinePropertyValue;
};
var myrho$yaml$Yaml$Parser$listInlineValue = myrho$yaml$Yaml$Parser$cyclic$listInlineValue();
myrho$yaml$Yaml$Parser$cyclic$listInlineValue = function () {
	return myrho$yaml$Yaml$Parser$listInlineValue;
};
var myrho$yaml$Yaml$Parser$listInline = myrho$yaml$Yaml$Parser$cyclic$listInline();
myrho$yaml$Yaml$Parser$cyclic$listInline = function () {
	return myrho$yaml$Yaml$Parser$listInline;
};
var myrho$yaml$Yaml$Parser$listInlineStepOne = myrho$yaml$Yaml$Parser$cyclic$listInlineStepOne();
myrho$yaml$Yaml$Parser$cyclic$listInlineStepOne = function () {
	return myrho$yaml$Yaml$Parser$listInlineStepOne;
};
var myrho$yaml$Yaml$Parser$recordInline = myrho$yaml$Yaml$Parser$cyclic$recordInline();
myrho$yaml$Yaml$Parser$cyclic$recordInline = function () {
	return myrho$yaml$Yaml$Parser$recordInline;
};
var myrho$yaml$Yaml$Parser$recordInlineStepOne = myrho$yaml$Yaml$Parser$cyclic$recordInlineStepOne();
myrho$yaml$Yaml$Parser$cyclic$recordInlineStepOne = function () {
	return myrho$yaml$Yaml$Parser$recordInlineStepOne;
};
var myrho$yaml$Yaml$Parser$Util$threeDashes = elm$parser$Parser$symbol('---');
var myrho$yaml$Yaml$Parser$Util$threeDots = elm$parser$Parser$symbol('...');
var myrho$yaml$Yaml$Parser$String$exceptions = function () {
	var dashed = function (s) {
		return '---' + s;
	};
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Null_),
				elm$parser$Parser$end),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A2(elm$core$Basics$composeL, myrho$yaml$Yaml$Parser$Ast$String_, dashed)),
					myrho$yaml$Yaml$Parser$Util$threeDashes),
				myrho$yaml$Yaml$Parser$Util$remaining),
				A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(myrho$yaml$Yaml$Parser$Ast$Null_),
					myrho$yaml$Yaml$Parser$Util$threeDots),
				myrho$yaml$Yaml$Parser$Util$remaining)
			]));
}();
var myrho$yaml$Yaml$Parser$value = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			myrho$yaml$Yaml$Parser$String$exceptions,
			myrho$yaml$Yaml$Parser$recordInline,
			myrho$yaml$Yaml$Parser$listInline,
			A2(elm$parser$Parser$andThen, myrho$yaml$Yaml$Parser$list, elm$parser$Parser$getCol),
			A2(
			elm$parser$Parser$andThen,
			myrho$yaml$Yaml$Parser$recordOrString(0),
			elm$parser$Parser$getCol)
		]));
var myrho$yaml$Yaml$Parser$Document$dashes = function (indent) {
	return (indent === 1) ? elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(elm$core$Basics$identity),
					myrho$yaml$Yaml$Parser$Util$threeDashes),
				myrho$yaml$Yaml$Parser$Util$whitespace),
				A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(elm$core$Basics$identity),
				myrho$yaml$Yaml$Parser$Util$whitespace)
			])) : A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(elm$core$Basics$identity),
		myrho$yaml$Yaml$Parser$Util$whitespace);
};
var myrho$yaml$Yaml$Parser$Document$begins = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(elm$core$Basics$identity),
				myrho$yaml$Yaml$Parser$Util$whitespace),
			A2(elm$parser$Parser$andThen, myrho$yaml$Yaml$Parser$Document$dashes, elm$parser$Parser$getCol)),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			myrho$yaml$Yaml$Parser$Util$whitespace)
		]));
var myrho$yaml$Yaml$Parser$Document$ends = A2(
	elm$parser$Parser$ignorer,
	A2(
		elm$parser$Parser$ignorer,
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(elm$core$Basics$identity),
				myrho$yaml$Yaml$Parser$Util$whitespace),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						myrho$yaml$Yaml$Parser$Util$threeDots,
						elm$parser$Parser$succeed(0)
					]))),
		myrho$yaml$Yaml$Parser$Util$whitespace),
	elm$parser$Parser$end);
var myrho$yaml$Yaml$Parser$parser = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$ignorer,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			myrho$yaml$Yaml$Parser$Document$begins),
		myrho$yaml$Yaml$Parser$Util$whitespace),
	A2(elm$parser$Parser$ignorer, myrho$yaml$Yaml$Parser$value, myrho$yaml$Yaml$Parser$Document$ends));
var myrho$yaml$Yaml$Parser$fromString = A2(
	elm$core$Basics$composeR,
	elm$parser$Parser$run(myrho$yaml$Yaml$Parser$parser),
	A2(
		elm$core$Basics$composeR,
		elm$core$Result$mapError(myrho$yaml$Yaml$Parser$deadEndsToString),
		elm$core$Result$map(myrho$yaml$Yaml$Parser$deref)));
var myrho$yaml$Yaml$Decode$fromString = F2(
	function (decoder, raw) {
		var _n0 = myrho$yaml$Yaml$Parser$fromString(raw);
		if (!_n0.$) {
			var v = _n0.a;
			return A2(myrho$yaml$Yaml$Decode$fromValue, decoder, v);
		} else {
			var error = _n0.a;
			return elm$core$Result$Err(
				myrho$yaml$Yaml$Decode$Parsing(error));
		}
	});
var author$project$Content$parseMeta = function (ymlStr) {
	var resYml = A2(myrho$yaml$Yaml$Decode$fromString, author$project$Content$decodeMetas, ymlStr);
	if (!resYml.$) {
		var res = resYml.a;
		return res;
	} else {
		return _List_Nil;
	}
};
var elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var author$project$Content$selectMeta = F2(
	function (key, metas) {
		return elm$core$List$head(
			A2(
				elm$core$List$filter,
				function (x) {
					return _Utils_eq(x.at, key) || _Utils_eq(x.at, key + '/index');
				},
				metas));
	});
var elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var elm$browser$Browser$Dom$NotFound = elm$core$Basics$identity;
var elm$core$Basics$never = function (_n0) {
	never:
	while (true) {
		var nvr = _n0;
		var $temp$_n0 = nvr;
		_n0 = $temp$_n0;
		continue never;
	}
};
var elm$core$Task$Perform = elm$core$Basics$identity;
var elm$core$Task$init = elm$core$Task$succeed(0);
var elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var elm$core$Task$spawnCmd = F2(
	function (router, _n0) {
		var task = _n0;
		return _Scheduler_spawn(
			A2(
				elm$core$Task$andThen,
				elm$core$Platform$sendToApp(router),
				task));
	});
var elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			elm$core$Task$map,
			function (_n0) {
				return 0;
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$map,
					elm$core$Task$spawnCmd(router),
					commands)));
	});
var elm$core$Task$onSelfMsg = F3(
	function (_n0, _n1, _n2) {
		return elm$core$Task$succeed(0);
	});
var elm$core$Task$cmdMap = F2(
	function (tagger, _n0) {
		var task = _n0;
		return A2(elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
var elm$core$Task$command = _Platform_leaf('Task');
var elm$core$Task$perform = F2(
	function (toMessage, task) {
		return elm$core$Task$command(
			A2(elm$core$Task$map, toMessage, task));
	});
var elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			elm$core$String$slice,
			n,
			elm$core$String$length(string),
			string);
	});
var elm$core$String$startsWith = _String_startsWith;
var elm$url$Url$Http = 0;
var elm$url$Url$Https = 1;
var elm$core$String$indexes = _String_indexes;
var elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
	});
var elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {an: fragment, aT: host, b_: path, a2: port_, a6: protocol, O: query};
	});
var elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, ':', str);
			if (!_n0.b) {
				return elm$core$Maybe$Just(
					A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_n0.b.b) {
					var i = _n0.a;
					var _n1 = elm$core$String$toInt(
						A2(elm$core$String$dropLeft, i + 1, str));
					if (_n1.$ === 1) {
						return elm$core$Maybe$Nothing;
					} else {
						var port_ = _n1;
						return elm$core$Maybe$Just(
							A6(
								elm$url$Url$Url,
								protocol,
								A2(elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return elm$core$Maybe$Nothing;
				}
			}
		}
	});
var elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '/', str);
			if (!_n0.b) {
				return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _n0.a;
				return A5(
					elm$url$Url$chompBeforePath,
					protocol,
					A2(elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '?', str);
			if (!_n0.b) {
				return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _n0.a;
				return A4(
					elm$url$Url$chompBeforeQuery,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '#', str);
			if (!_n0.b) {
				return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
			} else {
				var i = _n0.a;
				return A3(
					elm$url$Url$chompBeforeFragment,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$fromString = function (str) {
	return A2(elm$core$String$startsWith, 'http://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		0,
		A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		1,
		A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
};
var elm$browser$Browser$Dom$getElement = _Browser_getElement;
var elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var elm$core$Task$onError = _Scheduler_onError;
var elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return elm$core$Task$command(
			A2(
				elm$core$Task$onError,
				A2(
					elm$core$Basics$composeL,
					A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
					elm$core$Result$Err),
				A2(
					elm$core$Task$andThen,
					A2(
						elm$core$Basics$composeL,
						A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
						elm$core$Result$Ok),
					task)));
	});
var author$project$Content$toHeadingViewport = F2(
	function (f, fragment) {
		return A2(
			elm$core$Task$attempt,
			f,
			A2(
				elm$core$Task$andThen,
				function (el) {
					return A2(elm$browser$Browser$Dom$setViewport, 0, el.bG.cd);
				},
				elm$browser$Browser$Dom$getElement(fragment)));
	});
var elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var elm$core$Platform$Cmd$batch = _Platform_batch;
var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
var elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var elm$html$Html$node = elm$virtual_dom$VirtualDom$node;
var elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var elm$html$Html$Attributes$property = elm$virtual_dom$VirtualDom$property;
var elm$json$Json$Encode$string = _Json_wrap;
var author$project$Content$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var str = msg.a;
				var metas = author$project$Content$parseMeta(str);
				var _n1 = function () {
					var _n2 = model.at;
					if (_n2 === '') {
						return _Utils_Tuple2(3, elm$core$Platform$Cmd$none);
					} else {
						var slug = _n2;
						return _Utils_Tuple2(
							0,
							A2(
								elm$core$Task$perform,
								function (_n3) {
									var r = _n3.a;
									var s = _n3.b;
									return A2(author$project$Content$FetchContent, r, s);
								},
								elm$core$Task$succeed(
									_Utils_Tuple2(slug, model.O))));
					}
				}();
				var loadingState = _n1.a;
				var fetchCmd = _n1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{K: metas, Z: elm$core$Maybe$Nothing, aa: loadingState}),
					fetchCmd);
			case 0:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: elm$core$Maybe$Just(str),
							aa: 2
						}),
					A2(
						elm$core$Task$perform,
						author$project$Content$DoEmbed,
						elm$core$Task$succeed(str)));
			case 1:
				var slug = msg.a;
				var tocRaw = msg.b;
				return (!_Utils_eq(model.at, slug)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{E: elm$core$Maybe$Nothing}),
					elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: elm$core$Maybe$Just(
								A3(
									elm$html$Html$node,
									'embed-matter',
									_List_fromArray(
										[
											A2(
											elm$html$Html$Attributes$property,
											'content',
											elm$json$Json$Encode$string(tocRaw))
										]),
									_List_Nil))
						}),
					elm$core$Platform$Cmd$none);
			case 4:
				var str = msg.a;
				var dom = A3(
					elm$html$Html$node,
					'embed-matter',
					_List_fromArray(
						[
							A2(
							elm$html$Html$Attributes$property,
							'content',
							elm$json$Json$Encode$string(str))
						]),
					_List_Nil);
				return _Utils_Tuple2(
					model,
					A2(
						elm$core$Task$perform,
						author$project$Content$DoScroll,
						elm$core$Task$succeed(dom)));
			case 3:
				var slug = msg.a;
				var query = msg.b;
				var hasExt = 1 < elm$core$List$length(
					A2(elm$core$String$split, '.', query));
				var contentMeta = A2(author$project$Content$selectMeta, slug, model.K);
				var hasToc = A2(
					elm$core$Maybe$withDefault,
					false,
					A2(
						elm$core$Maybe$andThen,
						function ($) {
							return $.E;
						},
						contentMeta));
				return (!elm$core$List$length(model.K)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{O: query, at: slug}),
					A2(
						author$project$Api$fetch,
						author$project$Content$GotMetas,
						_Utils_ap(model.am, author$project$Common$metaFilename))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: query,
							at: slug,
							aa: 0,
							E: (!_Utils_eq(model.at, slug)) ? elm$core$Maybe$Nothing : model.E
						}),
					((slug === '') || (_Utils_eq(model.at, slug) && (_Utils_eq(model.O, query) && (!_Utils_eq(model.Z, elm$core$Maybe$Nothing))))) ? A2(
						elm$core$Task$perform,
						author$project$Content$GotContent,
						elm$core$Task$succeed(
							A2(elm$core$Maybe$withDefault, '', model.Z))) : elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								author$project$Api$fetch,
								author$project$Content$GotContent,
								_Utils_ap(
									model.am,
									_Utils_ap(
										slug,
										_Utils_ap(
											(query !== '') ? ('/' + query) : '',
											hasExt ? '' : '.html')))),
								hasToc ? A2(
								author$project$Api$fetch,
								author$project$Content$GotToc(slug),
								model.am + ('toc/' + (slug + (((query !== '') ? ('/' + query) : '') + (hasExt ? '' : '.html'))))) : elm$core$Platform$Cmd$none
							])));
			case 5:
				var dom = msg.a;
				var handleScroll = function (result) {
					if (!result.$) {
						return author$project$Content$NoOp('Ok');
					} else {
						var s = result.a;
						return author$project$Content$NoOp(s);
					}
				};
				var scrollCmd = function () {
					var _n4 = model.an;
					if (_n4 === '') {
						return elm$core$Platform$Cmd$none;
					} else {
						var f = _n4;
						return A2(author$project$Content$toHeadingViewport, handleScroll, f);
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aH: dom, aa: 3}),
					scrollCmd);
			default:
				return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
		}
	});
var author$project$Content$getOrCreate = F6(
	function (source, slug, query, fragment, page, maybeModel) {
		var _n0 = A5(author$project$Content$init, source, slug, query, fragment, page);
		var model = _n0.a;
		var cmd = _n0.b;
		if (maybeModel.$ === 1) {
			return _Utils_Tuple2(model, cmd);
		} else {
			var oldModel = maybeModel.a;
			return _Utils_eq(oldModel.a0, page) ? A2(
				author$project$Content$update,
				A2(author$project$Content$FetchContent, slug, query),
				_Utils_update(
					oldModel,
					{an: fragment, K: oldModel.K})) : _Utils_Tuple2(model, cmd);
		}
	});
var author$project$Pages$Detail$GotContentMsg = elm$core$Basics$identity;
var author$project$Pages$Init$Model = F3(
	function (overviews, detail, contentModel) {
		return {q: contentModel, ae: detail, Y: overviews};
	});
var author$project$Pages$Detail$Early = 0;
var author$project$Pages$Detail$Mature = 1;
var elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return elm$core$Maybe$Just(
				f(value));
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var author$project$Pages$Init$metaToOverview = function (meta) {
	var projectStage = A2(
		elm$core$Maybe$map,
		function (arg) {
			return (elm$core$String$toLower(arg) === 'early') ? 0 : 1;
		},
		meta.aw);
	return {aE: meta.aE, bE: meta.bE, bR: meta.bR, at: meta.at, b2: projectStage, bp: meta.bp, br: meta.br};
};
var elm$core$Platform$Cmd$map = _Platform_map;
var author$project$Pages$Init$init = F6(
	function (source, slug, query, fragment, maybeContentModel, contentPage) {
		var _n0 = A6(author$project$Content$getOrCreate, source, slug, query, fragment, contentPage, maybeContentModel);
		var contentModel = _n0.a;
		var contentCmd = _n0.b;
		var model = A3(
			author$project$Pages$Init$Model,
			A2(elm$core$List$map, author$project$Pages$Init$metaToOverview, contentModel.K),
			elm$core$Maybe$Nothing,
			contentModel);
		return _Utils_Tuple2(
			model,
			A2(elm$core$Platform$Cmd$map, elm$core$Basics$identity, contentCmd));
	});
var author$project$Pages$Blog$Init$init = F5(
	function (flags, slug, query, fragment, maybeContentModel) {
		var source = author$project$Pages$Blog$Init$decodeSource(flags);
		var _n0 = A6(author$project$Pages$Init$init, source, slug, query, fragment, maybeContentModel, 1);
		var model = _n0.a;
		var cmd = _n0.b;
		return _Utils_Tuple2(model, cmd);
	});
var author$project$Content$Notes = 2;
var author$project$Pages$Notes$Init$sourceDecoder = A2(elm$json$Json$Decode$field, 'notes-source', elm$json$Json$Decode$string);
var author$project$Pages$Notes$Init$decodeSource = function (flags) {
	var resultSource = A2(elm$json$Json$Decode$decodeValue, author$project$Pages$Notes$Init$sourceDecoder, flags);
	if (!resultSource.$) {
		var src = resultSource.a;
		return src;
	} else {
		return '';
	}
};
var author$project$Pages$Notes$Init$init = F5(
	function (flags, slug, query, fragment, maybeContentModel) {
		var source = author$project$Pages$Notes$Init$decodeSource(flags);
		var _n0 = A6(author$project$Pages$Init$init, source, slug, query, fragment, maybeContentModel, 2);
		var model = _n0.a;
		var cmd = _n0.b;
		return _Utils_Tuple2(model, cmd);
	});
var author$project$Content$Projects = 0;
var author$project$Pages$Projects$Init$sourceDecoder = A2(elm$json$Json$Decode$field, 'projects-source', elm$json$Json$Decode$string);
var author$project$Pages$Projects$Init$decodeSource = function (flags) {
	var resultSource = A2(elm$json$Json$Decode$decodeValue, author$project$Pages$Projects$Init$sourceDecoder, flags);
	if (!resultSource.$) {
		var src = resultSource.a;
		return src;
	} else {
		return '';
	}
};
var author$project$Pages$Projects$Init$init = F5(
	function (flags, slug, query, fragment, maybeContentModel) {
		var source = author$project$Pages$Projects$Init$decodeSource(flags);
		var _n0 = A6(author$project$Pages$Init$init, source, slug, query, fragment, maybeContentModel, 0);
		var model = _n0.a;
		var cmd = _n0.b;
		return _Utils_Tuple2(model, cmd);
	});
var author$project$Main$initializer = function (page) {
	switch (page) {
		case 0:
			return _Utils_Tuple3(author$project$Pages$Projects$Init$init, author$project$Main$Projects, author$project$Main$GotProjectsMsg);
		case 1:
			return _Utils_Tuple3(author$project$Pages$Blog$Init$init, author$project$Main$Blog, author$project$Main$GotBlogMsg);
		default:
			return _Utils_Tuple3(author$project$Pages$Notes$Init$init, author$project$Main$Notes, author$project$Main$GotNotesMsg);
	}
};
var author$project$Pages$Home$Init$Model = function (about) {
	return {G: about};
};
var author$project$Pages$Home$Init$About = F3(
	function (title, subtitle, about) {
		return {G: about, bm: subtitle, br: title};
	});
var elm$json$Json$Decode$map3 = _Json_map3;
var author$project$Pages$Home$Init$homeDecoder = A4(
	elm$json$Json$Decode$map3,
	author$project$Pages$Home$Init$About,
	A2(elm$json$Json$Decode$field, 'title', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'subtitle', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'about', elm$json$Json$Decode$string));
var author$project$Pages$Home$Init$rootDecoder = A2(elm$json$Json$Decode$field, 'home', author$project$Pages$Home$Init$homeDecoder);
var author$project$Pages$Home$Init$decodeAbout = function (value) {
	var res = A2(elm$json$Json$Decode$decodeValue, author$project$Pages$Home$Init$rootDecoder, value);
	var fallback = A3(author$project$Pages$Home$Init$About, '', '', '');
	if (!res.$) {
		var homeMe = res.a;
		return homeMe;
	} else {
		return fallback;
	}
};
var author$project$Pages$Home$Init$init = function (flags) {
	var about = author$project$Pages$Home$Init$decodeAbout(flags);
	return author$project$Pages$Home$Init$Model(about);
};
var elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		elm$json$Json$Decode$map,
		elm$core$Dict$fromList,
		elm$json$Json$Decode$keyValuePairs(decoder));
};
var author$project$Pages$Socials$Init$decodeSocialsField = A2(
	elm$json$Json$Decode$field,
	'socials',
	elm$json$Json$Decode$dict(elm$json$Json$Decode$string));
var author$project$Pages$Socials$Init$decodeSocials = function (value) {
	var decoded = A2(elm$json$Json$Decode$decodeValue, author$project$Pages$Socials$Init$decodeSocialsField, value);
	if (!decoded.$) {
		var result = decoded.a;
		return result;
	} else {
		return elm$core$Dict$empty;
	}
};
var author$project$Pages$Socials$Init$init = function (flags) {
	return author$project$Pages$Socials$Init$decodeSocials(flags);
};
var author$project$Route$Home = {$: 0};
var author$project$Route$routeToPieces = function (page) {
	switch (page.$) {
		case 0:
			return _List_Nil;
		case 1:
			switch (page.a) {
				case 0:
					var _n1 = page.a;
					var maybeStr = page.b;
					if (!maybeStr.$) {
						var str = maybeStr.a;
						return _List_fromArray(
							['projects', str]);
					} else {
						return _List_fromArray(
							['projects']);
					}
				case 1:
					var _n3 = page.a;
					var maybeStr = page.b;
					if (!maybeStr.$) {
						var str = maybeStr.a;
						return _List_fromArray(
							['blog', str]);
					} else {
						return _List_fromArray(
							['blog']);
					}
				default:
					var _n5 = page.a;
					var maybeStr = page.b;
					if (!maybeStr.$) {
						var str = maybeStr.a;
						return _List_fromArray(
							['notes', str]);
					} else {
						return _List_fromArray(
							['notes']);
					}
			}
		default:
			return _List_fromArray(
				['socials']);
	}
};
var elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2(elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var elm$core$List$takeTailRec = F2(
	function (n, list) {
		return elm$core$List$reverse(
			A3(elm$core$List$takeReverse, n, list, _List_Nil));
	});
var elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _n0 = _Utils_Tuple2(n, list);
			_n0$1:
			while (true) {
				_n0$5:
				while (true) {
					if (!_n0.b.b) {
						return list;
					} else {
						if (_n0.b.b.b) {
							switch (_n0.a) {
								case 1:
									break _n0$1;
								case 2:
									var _n2 = _n0.b;
									var x = _n2.a;
									var _n3 = _n2.b;
									var y = _n3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_n0.b.b.b.b) {
										var _n4 = _n0.b;
										var x = _n4.a;
										var _n5 = _n4.b;
										var y = _n5.a;
										var _n6 = _n5.b;
										var z = _n6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _n0$5;
									}
								default:
									if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
										var _n7 = _n0.b;
										var x = _n7.a;
										var _n8 = _n7.b;
										var y = _n8.a;
										var _n9 = _n8.b;
										var z = _n9.a;
										var _n10 = _n9.b;
										var w = _n10.a;
										var tl = _n10.b;
										return (ctr > 1000) ? A2(
											elm$core$List$cons,
											x,
											A2(
												elm$core$List$cons,
												y,
												A2(
													elm$core$List$cons,
													z,
													A2(
														elm$core$List$cons,
														w,
														A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											elm$core$List$cons,
											x,
											A2(
												elm$core$List$cons,
												y,
												A2(
													elm$core$List$cons,
													z,
													A2(
														elm$core$List$cons,
														w,
														A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _n0$5;
									}
							}
						} else {
							if (_n0.a === 1) {
								break _n0$1;
							} else {
								break _n0$5;
							}
						}
					}
				}
				return list;
			}
			var _n1 = _n0.b;
			var x = _n1.a;
			return _List_fromArray(
				[x]);
		}
	});
var elm$core$List$take = F2(
	function (n, list) {
		return A3(elm$core$List$takeFast, 0, n, list);
	});
var author$project$Route$root = function (route) {
	return '/' + A2(
		elm$core$Maybe$withDefault,
		'notfound',
		elm$core$List$head(
			A2(
				elm$core$List$take,
				1,
				author$project$Route$routeToPieces(route))));
};
var author$project$Route$routeToTask = function (route) {
	return elm$core$Task$succeed(
		author$project$Route$root(route));
};
var author$project$Main$changeRouteTo = F6(
	function (maybeRoute, components, navKey, flags, fragment, maybeContentModel) {
		var partial = A3(author$project$Main$Model, components, flags, navKey);
		var hook = A2(
			elm$core$Task$perform,
			author$project$Main$ChangedPage,
			author$project$Route$routeToTask(
				A2(elm$core$Maybe$withDefault, author$project$Route$Home, maybeRoute)));
		var homeModel = author$project$Pages$Home$Init$init(flags);
		if (maybeRoute.$ === 1) {
			return _Utils_Tuple2(
				A2(partial, elm$core$Maybe$Nothing, author$project$Main$NotFound),
				hook);
		} else {
			switch (maybeRoute.a.$) {
				case 0:
					var _n1 = maybeRoute.a;
					return _Utils_Tuple2(
						A2(
							partial,
							elm$core$Maybe$Nothing,
							author$project$Main$Home(homeModel)),
						elm$core$Platform$Cmd$none);
				case 1:
					var _n2 = maybeRoute.a;
					var page = _n2.a;
					var maybeSlug = _n2.b;
					var maybeQuery = _n2.c;
					var slug = A2(elm$core$Maybe$withDefault, '', maybeSlug);
					var query = A2(elm$core$Maybe$withDefault, '', maybeQuery);
					var _n3 = author$project$Main$initializer(page);
					var init_ = _n3.a;
					var pageName = _n3.b;
					var msgName = _n3.c;
					var _n4 = A5(init_, flags, slug, query, fragment, maybeContentModel);
					var pageModel = _n4.a;
					var pageCmd = _n4.b;
					return _Utils_Tuple2(
						A2(
							partial,
							maybeContentModel,
							pageName(pageModel)),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(elm$core$Platform$Cmd$map, msgName, pageCmd),
									hook
								])));
				default:
					var _n5 = maybeRoute.a;
					return _Utils_Tuple2(
						A2(
							partial,
							elm$core$Maybe$Nothing,
							author$project$Main$Socials(
								author$project$Pages$Socials$Init$init(flags))),
						hook);
			}
		}
	});
var author$project$Route$Blog = 1;
var author$project$Route$ContentRoute = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var author$project$Route$Notes = 2;
var author$project$Route$Projects = 0;
var author$project$Route$Socials = {$: 2};
var elm$url$Url$Parser$Parser = elm$core$Basics$identity;
var elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {B: frag, C: params, A: unvisited, v: value, F: visited};
	});
var elm$url$Url$Parser$mapState = F2(
	function (func, _n0) {
		var visited = _n0.F;
		var unvisited = _n0.A;
		var params = _n0.C;
		var frag = _n0.B;
		var value = _n0.v;
		return A5(
			elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var elm$url$Url$Parser$map = F2(
	function (subValue, _n0) {
		var parseArg = _n0;
		return function (_n1) {
			var visited = _n1.F;
			var unvisited = _n1.A;
			var params = _n1.C;
			var frag = _n1.B;
			var value = _n1.v;
			return A2(
				elm$core$List$map,
				elm$url$Url$Parser$mapState(value),
				parseArg(
					A5(elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
		}
	});
var elm$core$List$concat = function (lists) {
	return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
};
var elm$core$List$concatMap = F2(
	function (f, list) {
		return elm$core$List$concat(
			A2(elm$core$List$map, f, list));
	});
var elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			elm$core$List$concatMap,
			function (_n0) {
				var parser = _n0;
				return parser(state);
			},
			parsers);
	};
};
var elm$url$Url$Parser$query = function (_n0) {
	var queryParser = _n0;
	return function (_n1) {
		var visited = _n1.F;
		var unvisited = _n1.A;
		var params = _n1.C;
		var frag = _n1.B;
		var value = _n1.v;
		return _List_fromArray(
			[
				A5(
				elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var elm$url$Url$Parser$slash = F2(
	function (_n0, _n1) {
		var parseBefore = _n0;
		var parseAfter = _n1;
		return function (state) {
			return A2(
				elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			elm$url$Url$Parser$slash,
			parser,
			elm$url$Url$Parser$query(queryParser));
	});
var elm$url$Url$Parser$s = function (str) {
	return function (_n0) {
		var visited = _n0.F;
		var unvisited = _n0.A;
		var params = _n0.C;
		var frag = _n0.B;
		var value = _n0.v;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					elm$url$Url$Parser$State,
					A2(elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_n0) {
			var visited = _n0.F;
			var unvisited = _n0.A;
			var params = _n0.C;
			var frag = _n0.B;
			var value = _n0.v;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _n2 = stringToSomething(next);
				if (!_n2.$) {
					var nextValue = _n2.a;
					return _List_fromArray(
						[
							A5(
							elm$url$Url$Parser$State,
							A2(elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var elm$url$Url$Parser$string = A2(elm$url$Url$Parser$custom, 'STRING', elm$core$Maybe$Just);
var elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var elm$url$Url$Parser$Internal$Parser = elm$core$Basics$identity;
var elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					A2(elm$core$Dict$get, key, dict)));
		};
	});
var elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return elm$core$Maybe$Just(str);
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
};
var author$project$Route$parser = elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(elm$url$Url$Parser$map, author$project$Route$Home, elm$url$Url$Parser$top),
			A2(
			elm$url$Url$Parser$map,
			A2(author$project$Route$ContentRoute, 0, elm$core$Maybe$Nothing),
			A2(
				elm$url$Url$Parser$questionMark,
				elm$url$Url$Parser$s('projects'),
				elm$url$Url$Parser$Query$string('q'))),
			A2(
			elm$url$Url$Parser$map,
			function (r) {
				return A3(
					author$project$Route$ContentRoute,
					0,
					elm$core$Maybe$Just(r),
					elm$core$Maybe$Nothing);
			},
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('projects'),
				elm$url$Url$Parser$string)),
			A2(
			elm$url$Url$Parser$map,
			F2(
				function (r, p) {
					return A3(
						author$project$Route$ContentRoute,
						0,
						elm$core$Maybe$Just(r),
						(p === '') ? elm$core$Maybe$Nothing : elm$core$Maybe$Just(p));
				}),
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('projects'),
				A2(elm$url$Url$Parser$slash, elm$url$Url$Parser$string, elm$url$Url$Parser$string))),
			A2(
			elm$url$Url$Parser$map,
			A2(author$project$Route$ContentRoute, 1, elm$core$Maybe$Nothing),
			A2(
				elm$url$Url$Parser$questionMark,
				elm$url$Url$Parser$s('blog'),
				elm$url$Url$Parser$Query$string('q'))),
			A2(
			elm$url$Url$Parser$map,
			function (r) {
				return A3(
					author$project$Route$ContentRoute,
					1,
					elm$core$Maybe$Just(r),
					elm$core$Maybe$Nothing);
			},
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('blog'),
				elm$url$Url$Parser$string)),
			A2(
			elm$url$Url$Parser$map,
			F2(
				function (r, p) {
					return A3(
						author$project$Route$ContentRoute,
						1,
						elm$core$Maybe$Just(r),
						(p === '') ? elm$core$Maybe$Nothing : elm$core$Maybe$Just(p));
				}),
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('blog'),
				A2(elm$url$Url$Parser$slash, elm$url$Url$Parser$string, elm$url$Url$Parser$string))),
			A2(
			elm$url$Url$Parser$map,
			A2(author$project$Route$ContentRoute, 2, elm$core$Maybe$Nothing),
			A2(
				elm$url$Url$Parser$questionMark,
				elm$url$Url$Parser$s('notes'),
				elm$url$Url$Parser$Query$string('q'))),
			A2(
			elm$url$Url$Parser$map,
			function (r) {
				return A3(
					author$project$Route$ContentRoute,
					2,
					elm$core$Maybe$Just(r),
					elm$core$Maybe$Nothing);
			},
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('notes'),
				elm$url$Url$Parser$string)),
			A2(
			elm$url$Url$Parser$map,
			F2(
				function (r, p) {
					return A3(
						author$project$Route$ContentRoute,
						2,
						elm$core$Maybe$Just(r),
						(p === '') ? elm$core$Maybe$Nothing : elm$core$Maybe$Just(p));
				}),
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('notes'),
				A2(elm$url$Url$Parser$slash, elm$url$Url$Parser$string, elm$url$Url$Parser$string))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Socials,
			elm$url$Url$Parser$s('socials'))
		]));
var elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _n1 = state.A;
			if (!_n1.b) {
				return elm$core$Maybe$Just(state.v);
			} else {
				if ((_n1.a === '') && (!_n1.b.b)) {
					return elm$core$Maybe$Just(state.v);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				elm$core$List$cons,
				segment,
				elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var elm$url$Url$Parser$preparePath = function (path) {
	var _n0 = A2(elm$core$String$split, '/', path);
	if (_n0.b && (_n0.a === '')) {
		var segments = _n0.b;
		return elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _n0;
		return elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var elm$url$Url$percentDecode = _Url_percentDecode;
var elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return elm$core$Maybe$Just(
				A2(elm$core$List$cons, value, list));
		}
	});
var elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _n0 = A2(elm$core$String$split, '=', segment);
		if ((_n0.b && _n0.b.b) && (!_n0.b.b.b)) {
			var rawKey = _n0.a;
			var _n1 = _n0.b;
			var rawValue = _n1.a;
			var _n2 = elm$url$Url$percentDecode(rawKey);
			if (_n2.$ === 1) {
				return dict;
			} else {
				var key = _n2.a;
				var _n3 = elm$url$Url$percentDecode(rawValue);
				if (_n3.$ === 1) {
					return dict;
				} else {
					var value = _n3.a;
					return A3(
						elm$core$Dict$update,
						key,
						elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			elm$core$List$foldr,
			elm$url$Url$Parser$addParam,
			elm$core$Dict$empty,
			A2(elm$core$String$split, '&', qry));
	}
};
var elm$url$Url$Parser$parse = F2(
	function (_n0, url) {
		var parser = _n0;
		return elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					elm$url$Url$Parser$State,
					_List_Nil,
					elm$url$Url$Parser$preparePath(url.b_),
					elm$url$Url$Parser$prepareQuery(url.O),
					url.an,
					elm$core$Basics$identity)));
	});
var author$project$Route$fromUrl = function (url) {
	return A2(elm$url$Url$Parser$parse, author$project$Route$parser, url);
};
var author$project$Main$init = F3(
	function (flags, url, navKey) {
		var contentModel = elm$core$Maybe$Nothing;
		var bodyInit = author$project$Components$Body$init(flags);
		var barInit = author$project$Components$Sidebar$init(url.b_);
		var components = A2(author$project$Main$Components, bodyInit, barInit);
		return A6(
			author$project$Main$changeRouteTo,
			author$project$Route$fromUrl(url),
			components,
			navKey,
			flags,
			A2(elm$core$Maybe$withDefault, '', url.an),
			contentModel);
	});
var elm$core$Platform$Sub$batch = _Platform_batch;
var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
var author$project$Main$subscriptions = function (model) {
	return elm$core$Platform$Sub$none;
};
var author$project$Components$Sidebar$update = F2(
	function (msg, model) {
		var link = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					V: A2(
						elm$core$List$map,
						function (partial) {
							return partial(
								_Utils_eq(
									partial(false).bR,
									link));
						},
						author$project$Components$Sidebar$linksPartial)
				}),
			elm$core$Platform$Cmd$none);
	});
var author$project$Components$Sidebar$ChangeActiveLink = elm$core$Basics$identity;
var author$project$Components$Sidebar$updateActiveLink = function (link) {
	return A2(
		author$project$Components$Sidebar$update,
		link,
		{V: _List_Nil});
};
var author$project$Main$GotSidebarMsg = function (a) {
	return {$: 3, a: a};
};
var author$project$Main$updateWith = F4(
	function (model, toModel, gotMsg, subUpdate) {
		var subModel = subUpdate.a;
		var subCmd = subUpdate.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					a0: toModel(subModel)
				}),
			A2(elm$core$Platform$Cmd$map, gotMsg, subCmd));
	});
var elm$core$List$sortBy = _List_sortBy;
var elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var elm$html$Html$map = elm$virtual_dom$VirtualDom$map;
var author$project$Pages$Init$update = F2(
	function (msg, model) {
		var contentMsg = msg;
		var key = (model.q.O !== '') ? (model.q.at + '/index') : model.q.at;
		var contentIndex = A2(author$project$Content$selectMeta, key, model.q.K);
		var _n1 = A2(author$project$Content$update, contentMsg, model.q);
		var contentModel = _n1.a;
		var contentCmd = _n1.b;
		var _n2 = _Utils_Tuple2(contentModel.K, contentModel.aH);
		var indices = _n2.a;
		var content = _n2.b;
		var detail = A2(
			elm$core$Maybe$map,
			function (overview) {
				return {
					aD: A2(elm$html$Html$map, elm$core$Basics$identity, content),
					ai: overview,
					E: A2(
						elm$core$Maybe$map,
						elm$html$Html$map(elm$core$Basics$identity),
						contentModel.E)
				};
			},
			A2(elm$core$Maybe$map, author$project$Pages$Init$metaToOverview, contentIndex));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					q: contentModel,
					ae: detail,
					Y: elm$core$List$reverse(
						A2(
							elm$core$List$sortBy,
							function ($) {
								return $.aE;
							},
							A2(elm$core$List$map, author$project$Pages$Init$metaToOverview, indices)))
				}),
			A2(elm$core$Platform$Cmd$map, elm$core$Basics$identity, contentCmd));
	});
var author$project$Pages$Blog$Init$update = F2(
	function (msg, model) {
		return A2(author$project$Pages$Init$update, msg, model);
	});
var author$project$Pages$Notes$Init$update = F2(
	function (msg, model) {
		return A2(author$project$Pages$Init$update, msg, model);
	});
var author$project$Pages$Projects$Init$update = F2(
	function (msg, model) {
		return A2(author$project$Pages$Init$update, msg, model);
	});
var elm$browser$Browser$Navigation$load = _Browser_load;
var elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + elm$core$String$fromInt(port_));
		}
	});
var elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var elm$url$Url$toString = function (url) {
	var http = function () {
		var _n0 = url.a6;
		if (!_n0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		elm$url$Url$addPrefixed,
		'#',
		url.an,
		A3(
			elm$url$Url$addPrefixed,
			'?',
			url.O,
			_Utils_ap(
				A2(
					elm$url$Url$addPort,
					url.a2,
					_Utils_ap(http, url.aT)),
				url.b_)));
};
var author$project$Main$update = F2(
	function (msg, model) {
		var _n0 = _Utils_Tuple2(msg, model.a0);
		_n0$7:
		while (true) {
			switch (_n0.a.$) {
				case 1:
					var urlRequest = _n0.a.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							model,
							A2(
								elm$browser$Browser$Navigation$pushUrl,
								model.ao,
								elm$url$Url$toString(url)));
					} else {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							model,
							elm$browser$Browser$Navigation$load(url));
					}
				case 0:
					var url = _n0.a.a;
					return A6(
						author$project$Main$changeRouteTo,
						author$project$Route$fromUrl(url),
						model.x,
						model.ao,
						model.aM,
						A2(elm$core$Maybe$withDefault, '', url.an),
						model.q);
				case 2:
					var internalLink = _n0.a.a;
					var components = model.x;
					var barUpdate = author$project$Components$Sidebar$updateActiveLink(internalLink);
					var bar = barUpdate.a;
					var cmd = barUpdate.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								x: _Utils_update(
									components,
									{T: bar})
							}),
						A2(elm$core$Platform$Cmd$map, author$project$Main$GotSidebarMsg, cmd));
				case 3:
					var subMsg = _n0.a.a;
					var components = model.x;
					var barUpdate = A2(author$project$Components$Sidebar$update, subMsg, components.T);
					var bar = barUpdate.a;
					var cmd = barUpdate.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								x: _Utils_update(
									components,
									{T: bar})
							}),
						A2(elm$core$Platform$Cmd$map, author$project$Main$GotSidebarMsg, cmd));
				case 4:
					if (_n0.b.$ === 2) {
						var subMsg = _n0.a.a;
						var projectsModel = _n0.b.a;
						var _n4 = A4(
							author$project$Main$updateWith,
							model,
							author$project$Main$Projects,
							author$project$Main$GotProjectsMsg,
							A2(author$project$Pages$Projects$Init$update, subMsg, projectsModel));
						var model_ = _n4.a;
						var cmd = _n4.b;
						var updatedContentModel = function () {
							var _n5 = model_.a0;
							if (_n5.$ === 2) {
								var updatedProjectsModel = _n5.a;
								return updatedProjectsModel.q;
							} else {
								return projectsModel.q;
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model_,
								{
									q: elm$core$Maybe$Just(updatedContentModel)
								}),
							cmd);
					} else {
						break _n0$7;
					}
				case 5:
					if (_n0.b.$ === 3) {
						var subMsg = _n0.a.a;
						var blogModel = _n0.b.a;
						var _n6 = A4(
							author$project$Main$updateWith,
							model,
							author$project$Main$Blog,
							author$project$Main$GotBlogMsg,
							A2(author$project$Pages$Blog$Init$update, subMsg, blogModel));
						var model_ = _n6.a;
						var cmd = _n6.b;
						var updatedContentModel = function () {
							var _n7 = model_.a0;
							if (_n7.$ === 3) {
								var updatedBlogModel = _n7.a;
								return updatedBlogModel.q;
							} else {
								return blogModel.q;
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model_,
								{
									q: elm$core$Maybe$Just(updatedContentModel)
								}),
							cmd);
					} else {
						break _n0$7;
					}
				case 6:
					if (_n0.b.$ === 4) {
						var subMsg = _n0.a.a;
						var notesModel = _n0.b.a;
						var _n8 = A4(
							author$project$Main$updateWith,
							model,
							author$project$Main$Notes,
							author$project$Main$GotNotesMsg,
							A2(author$project$Pages$Notes$Init$update, subMsg, notesModel));
						var model_ = _n8.a;
						var cmd = _n8.b;
						var updatedContentModel = function () {
							var _n9 = model_.a0;
							if (_n9.$ === 4) {
								var updatedNotesModel = _n9.a;
								return updatedNotesModel.q;
							} else {
								return notesModel.q;
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model_,
								{
									q: elm$core$Maybe$Just(updatedContentModel)
								}),
							cmd);
					} else {
						break _n0$7;
					}
				default:
					break _n0$7;
			}
		}
		return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
	});
var elm$html$Html$p = _VirtualDom_node('p');
var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var elm$html$Html$text = elm$virtual_dom$VirtualDom$text;
var elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			elm$json$Json$Encode$string(string));
	});
var elm$html$Html$Attributes$class = elm$html$Html$Attributes$stringProperty('className');
var author$project$Components$Body$view = F2(
	function (model, content) {
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('main')
						]),
					_List_fromArray(
						[content])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('footer')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									elm$html$Html$text('Copyright 2026 © Amanuel Tewodros Getachew. All rights reserved. Made with Elm')
								]))
						]))
				]));
	});
var author$project$Components$Sidebar$linkToDesc = function (link) {
	var path = A2(elm$core$String$split, '/', link);
	_n0$5:
	while (true) {
		if (path.b && (path.a === '')) {
			if (path.b.b && (!path.b.b.b)) {
				switch (path.b.a) {
					case '':
						var _n1 = path.b;
						return elm$core$Maybe$Just('about');
					case 'projects':
						var _n2 = path.b;
						return elm$core$Maybe$Just('projects');
					case 'blog':
						var _n3 = path.b;
						return elm$core$Maybe$Just('write-ups');
					case 'notes':
						var _n4 = path.b;
						return elm$core$Maybe$Just('notes');
					case 'socials':
						var _n5 = path.b;
						return elm$core$Maybe$Just('find me');
					default:
						break _n0$5;
				}
			} else {
				break _n0$5;
			}
		} else {
			return elm$core$Maybe$Nothing;
		}
	}
	var paths = path.b;
	return elm$core$Maybe$Just(
		A2(elm$core$String$join, '/', paths));
};
var elm$html$Html$a = _VirtualDom_node('a');
var elm$html$Html$i = _VirtualDom_node('i');
var elm$html$Html$li = _VirtualDom_node('li');
var elm$html$Html$Attributes$href = function (url) {
	return A2(
		elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			elm$virtual_dom$VirtualDom$on,
			event,
			elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var elm$html$Html$Events$onClick = function (msg) {
	return A2(
		elm$html$Html$Events$on,
		'click',
		elm$json$Json$Decode$succeed(msg));
};
var author$project$Components$Sidebar$linkToHtml = function (link) {
	var radius = 2;
	var listClass = 'sidebar-link-item' + (link.bD ? ' current-sidebar-link-item' : '');
	var toHtml = function (desc) {
		return A2(
			elm$html$Html$li,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class(listClass)
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$a,
					_List_fromArray(
						[
							elm$html$Html$Attributes$href(link.bR),
							elm$html$Html$Events$onClick(link.bR)
						]),
					_List_fromArray(
						[
							elm$html$Html$text(desc)
						])),
					A2(
					elm$html$Html$i,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('fa fa-circle sidebar-node')
						]),
					_List_Nil)
				]));
	};
	var center = _Utils_Tuple2(5, 5);
	return A2(
		elm$core$Maybe$map,
		toHtml,
		author$project$Components$Sidebar$linkToDesc(link.bR));
};
var author$project$Utils$isJust = function (ma) {
	if (!ma.$) {
		return true;
	} else {
		return false;
	}
};
var elm$html$Html$ul = _VirtualDom_node('ul');
var author$project$Components$Sidebar$view = function (model) {
	var listItems = A2(
		elm$core$List$map,
		elm$core$Maybe$withDefault(
			elm$html$Html$text('')),
		A2(
			elm$core$List$filter,
			author$project$Utils$isJust,
			A2(elm$core$List$map, author$project$Components$Sidebar$linkToHtml, model.V)));
	return A2(
		elm$html$Html$div,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('sidebar')
			]),
		_List_fromArray(
			[
				A2(
				elm$html$Html$ul,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('sidebar-links')
					]),
				listItems)
			]));
};
var author$project$Pages$Blog$Init$blogDescription = A2(
	elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			elm$html$Html$text('My find-outs and opinions on stuff')
		]));
var author$project$Pages$Blog$Init$blogHeading = elm$html$Html$text('Write-ups');
var author$project$Asset$Image = elm$core$Basics$identity;
var author$project$Asset$image = function (filename) {
	return '/img/' + filename;
};
var author$project$Asset$loading = author$project$Asset$image('infinite-spinner.svg');
var elm$html$Html$Attributes$src = function (url) {
	return A2(
		elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var author$project$Asset$src = function (_n0) {
	var url = _n0;
	return elm$html$Html$Attributes$src(url);
};
var author$project$Components$Card$htmlWithMaybe = F2(
	function (maybeStr, wrapper) {
		var maybeHtml = A2(elm$core$Maybe$map, wrapper, maybeStr);
		return A2(elm$core$Maybe$withDefault, author$project$Components$EmptyElement$view, maybeHtml);
	});
var elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var author$project$Utils$DateUtils$formatDateSimple = function (_n0) {
	var year = _n0.a;
	var month = _n0.b;
	var day = _n0.c;
	var monthStr = A2(
		elm$core$Maybe$withDefault,
		'?',
		elm$core$List$head(
			A2(
				elm$core$List$drop,
				month - 1,
				_List_fromArray(
					['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']))));
	return monthStr + (' ' + (elm$core$String$fromInt(day) + (', ' + elm$core$String$fromInt(year))));
};
var elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var author$project$Utils$DateUtils$parseDate = function (str) {
	var _n0 = A2(elm$core$String$split, '-', str);
	if (((_n0.b && _n0.b.b) && _n0.b.b.b) && (!_n0.b.b.b.b)) {
		var y = _n0.a;
		var _n1 = _n0.b;
		var m = _n1.a;
		var _n2 = _n1.b;
		var d = _n2.a;
		return A4(
			elm$core$Maybe$map3,
			F3(
				function (a, b, c) {
					return _Utils_Tuple3(a, b, c);
				}),
			elm$core$String$toInt(y),
			elm$core$String$toInt(m),
			elm$core$String$toInt(d));
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$Utils$DateUtils$formatYmd = function (ymd) {
	var _n0 = author$project$Utils$DateUtils$parseDate(ymd);
	if (!_n0.$) {
		var date = _n0.a;
		return author$project$Utils$DateUtils$formatDateSimple(date);
	} else {
		return ymd;
	}
};
var elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var elm$html$Html$h2 = _VirtualDom_node('h2');
var elm$html$Html$Attributes$id = elm$html$Html$Attributes$stringProperty('id');
var author$project$Components$Card$view = F2(
	function (base, model) {
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('card'),
					elm$html$Html$Attributes$id(model.at)
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$h2,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('card-title')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									elm$html$Html$Attributes$href(
									_Utils_ap(base, model.at))
								]),
							_List_fromArray(
								[
									elm$html$Html$text(model.br)
								]))
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('card-date')
						]),
					_List_fromArray(
						[
							elm$html$Html$text(
							author$project$Utils$DateUtils$formatYmd(model.aE))
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('card-subtitle')
						]),
					_List_fromArray(
						[
							elm$html$Html$text(model.bm)
						])),
					A2(
					author$project$Components$Card$htmlWithMaybe,
					model.bn,
					A2(
						elm$core$Basics$composeL,
						A2(
							elm$core$Basics$composeL,
							elm$html$Html$div(
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('card-subtitle2')
									])),
							elm$core$List$singleton),
						elm$html$Html$text)),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('card-section')
						]),
					_List_fromArray(
						[
							A2(
							author$project$Components$Card$htmlWithMaybe,
							model.aw,
							A2(
								elm$core$Basics$composeL,
								A2(
									elm$core$Basics$composeL,
									elm$html$Html$div(
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('card-status')
											])),
									elm$core$List$singleton),
								elm$html$Html$text)),
							A2(
							author$project$Components$Card$htmlWithMaybe,
							A2(
								elm$core$Maybe$map,
								function (_n0) {
									return '|';
								},
								model.aw),
							function (s) {
								return elm$html$Html$text(s);
							}),
							A2(
							author$project$Components$Card$htmlWithMaybe,
							model.a7,
							A2(
								elm$core$Basics$composeL,
								A2(
									elm$core$Basics$composeL,
									elm$html$Html$div(
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('card-link')
											])),
									elm$core$List$singleton),
								function (s) {
									return A2(
										elm$html$Html$a,
										_List_fromArray(
											[
												elm$html$Html$Attributes$href(s)
											]),
										_List_fromArray(
											[
												elm$html$Html$text('View Source')
											]));
								}))
						])),
					A2(
					elm$html$Html$ul,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('card-tags')
						]),
					A2(
						elm$core$List$map,
						elm$html$Html$li(
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('card-tag')
								])),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(
								elm$core$List$map,
								function (tag) {
									return A2(
										elm$html$Html$a,
										_List_fromArray(
											[
												elm$html$Html$Attributes$href(base + ('?q=' + tag))
											]),
										_List_fromArray(
											[
												elm$html$Html$text('#' + tag)
											]));
								},
								model.bp))))
				]));
	});
var elm$html$Html$h1 = _VirtualDom_node('h1');
var elm$html$Html$hr = _VirtualDom_node('hr');
var author$project$Pages$Detail$view = function (model) {
	var hasToc = _Utils_eq(model.E, elm$core$Maybe$Nothing) ? false : true;
	return A2(
		elm$html$Html$div,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class(
				'page-detail-super' + (hasToc ? '' : ' page-detail-super-without-toc'))
			]),
		_List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('page-detail-container')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('page-detail-meta')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										elm$html$Html$a,
										_List_fromArray(
											[
												elm$html$Html$Attributes$href(model.ai.bR)
											]),
										_List_fromArray(
											[
												elm$html$Html$text(model.ai.br)
											]))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('page-detail-date')
									]),
								_List_fromArray(
									[
										elm$html$Html$text(
										author$project$Utils$DateUtils$formatYmd(model.ai.aE))
									])),
								A2(elm$html$Html$hr, _List_Nil, _List_Nil)
							])),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('page-detail-content')
							]),
						_List_fromArray(
							[model.aD]))
					])),
				function () {
				var _n0 = model.E;
				if (_n0.$ === 1) {
					return author$project$Components$EmptyElement$view;
				} else {
					var toc = _n0.a;
					return A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('pages-detail-toc')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$p,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('pages-detail-toc-label')
									]),
								_List_fromArray(
									[
										elm$html$Html$text('Table of Contents')
									])),
								toc
							]));
				}
			}()
			]));
};
var author$project$Pages$Init$applyQuery = F2(
	function (query, metas) {
		return A2(
			elm$core$List$filter,
			function (r) {
				if (query === '') {
					return true;
				} else {
					var q = query;
					return A2(elm$core$List$member, q, r.bp);
				}
			},
			metas);
	});
var author$project$Pages$Init$projectStageToString = function (stage) {
	if (!stage) {
		return 'Early Stage';
	} else {
		return 'Relatively Mature';
	}
};
var author$project$Pages$Init$overviewToCardModel = function (overview) {
	return {
		aE: overview.aE,
		a7: elm$core$Maybe$Just(overview.bR),
		at: overview.at,
		aw: A2(elm$core$Maybe$map, author$project$Pages$Init$projectStageToString, overview.b2),
		bm: overview.bE,
		bn: elm$core$Maybe$Nothing,
		bp: overview.bp,
		br: overview.br
	};
};
var elm$html$Html$img = _VirtualDom_node('img');
var elm$html$Html$nav = _VirtualDom_node('nav');
var author$project$Pages$Init$view = F4(
	function (model, heading, description, root) {
		var loadingMessage = function () {
			var _n2 = model.q.aa;
			switch (_n2) {
				case 1:
					return 'Fetching front-matter...';
				case 0:
					return 'Fetching content...';
				case 2:
					return 'Preparing content';
				default:
					return '';
			}
		}();
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class(
					(!_Utils_eq(model.ae, elm$core$Maybe$Nothing)) ? 'pages-detail' : 'pages-root')
				]),
			function () {
				if (model.q.aa !== 3) {
					return _List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('infinite-spinner')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$img,
									_List_fromArray(
										[
											author$project$Asset$src(author$project$Asset$loading)
										]),
									_List_Nil),
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text(loadingMessage)
										]))
								]))
						]);
				} else {
					var _n0 = model.ae;
					if (_n0.$ === 1) {
						return _List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										elm$html$Html$h1,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('page-heading')
											]),
										_List_fromArray(
											[heading])),
										A2(
										elm$html$Html$p,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('pages-sub')
											]),
										_List_fromArray(
											[description])),
										A2(
										elm$html$Html$div,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('pages-overviews')
											]),
										A2(
											elm$core$List$cons,
											((model.q.O !== '') && (model.q.at === '')) ? A2(
												elm$html$Html$p,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('filter-info')
													]),
												_List_fromArray(
													[
														elm$html$Html$text('Showing results tagged \'' + (model.q.O + '\''))
													])) : author$project$Components$EmptyElement$view,
											A2(
												elm$core$List$map,
												A2(
													elm$core$Basics$composeL,
													author$project$Components$Card$view(root),
													author$project$Pages$Init$overviewToCardModel),
												A2(author$project$Pages$Init$applyQuery, model.q.O, model.Y))))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('pages-right-sidebar')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$nav,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('pages-nav')
											]),
										_List_fromArray(
											[
												A2(
												elm$html$Html$ul,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('pages-nav-ul'),
														elm$html$Html$Attributes$id('pages-nav-ul')
													]),
												A2(
													elm$core$List$map,
													function (x) {
														return A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	elm$html$Html$a,
																	_List_fromArray(
																		[
																			elm$html$Html$Attributes$href('#' + x.at)
																		]),
																	_List_fromArray(
																		[
																			elm$html$Html$text(x.br)
																		]))
																]));
													},
													A2(author$project$Pages$Init$applyQuery, model.q.O, model.Y)))
											])),
										A2(
										elm$html$Html$div,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('pages-tags')
											]),
										_List_fromArray(
											[
												A2(
												elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														elm$html$Html$text('Tags on this page')
													])),
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('pages-tags-list')
													]),
												A2(
													elm$core$List$map,
													function (_n1) {
														var k = _n1.a;
														var v = _n1.b;
														return A2(
															elm$html$Html$a,
															_List_fromArray(
																[
																	elm$html$Html$Attributes$href('?q=' + k)
																]),
															_List_fromArray(
																[
																	elm$html$Html$text(
																	k + ('(' + (elm$core$String$fromInt(v) + ')')))
																]));
													},
													A2(
														elm$core$List$sortBy,
														elm$core$Tuple$first,
														elm$core$Dict$toList(
															A3(
																elm$core$List$foldl,
																F2(
																	function (k, d) {
																		return A3(
																			elm$core$Dict$insert,
																			k,
																			1 + A2(
																				elm$core$Maybe$withDefault,
																				0,
																				A2(elm$core$Dict$get, k, d)),
																			d);
																	}),
																elm$core$Dict$empty,
																A3(
																	elm$core$List$foldl,
																	elm$core$List$append,
																	_List_Nil,
																	A2(
																		elm$core$List$map,
																		function ($) {
																			return $.bp;
																		},
																		model.Y)))))))
											]))
									]))
							]);
					} else {
						var detail = _n0.a;
						return _List_fromArray(
							[
								author$project$Pages$Detail$view(detail)
							]);
					}
				}
			}());
	});
var author$project$Pages$Blog$Init$view = function (model) {
	return A4(author$project$Pages$Init$view, model, author$project$Pages$Blog$Init$blogHeading, author$project$Pages$Blog$Init$blogDescription, '/blog/');
};
var author$project$Asset$homeDecoration = author$project$Asset$image('dirichlet-portrait-trace-slow.gif');
var elm$html$Html$span = _VirtualDom_node('span');
var elm_explorations$markdown$Markdown$defaultOptions = {
	aG: elm$core$Maybe$Nothing,
	aP: elm$core$Maybe$Just(
		{bA: false, b6: false}),
	bf: true,
	bi: false
};
var elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var elm_explorations$markdown$Markdown$toHtml = elm_explorations$markdown$Markdown$toHtmlWith(elm_explorations$markdown$Markdown$defaultOptions);
var author$project$Pages$Home$Init$view = function (model) {
	return A2(
		elm$html$Html$div,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('homepage')
			]),
		_List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('home_me section')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$h1,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$span,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('logo')
									]),
								_List_fromArray(
									[
										elm$html$Html$text('𝔡')
									])),
								elm$html$Html$text(model.G.br)
							])),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('subtitle')
							]),
						_List_fromArray(
							[
								elm$html$Html$text(model.G.bm)
							])),
						A2(
						elm$html$Html$img,
						_List_fromArray(
							[
								author$project$Asset$src(author$project$Asset$homeDecoration),
								elm$html$Html$Attributes$class('home-decoration'),
								A2(elm$html$Html$Attributes$style, 'opacity', '15%')
							]),
						_List_Nil)
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('logo-container')
					]),
				_List_Nil),
				A2(
				elm_explorations$markdown$Markdown$toHtml,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('about_me section')
					]),
				model.G.G)
			]));
};
var elm$html$Html$main_ = _VirtualDom_node('main');
var elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		elm$core$String$fromInt(n));
};
var author$project$Pages$NotFound$view = A2(
	elm$html$Html$main_,
	_List_fromArray(
		[
			elm$html$Html$Attributes$id('content'),
			elm$html$Html$Attributes$class('container'),
			elm$html$Html$Attributes$tabindex(-1)
		]),
	_List_fromArray(
		[
			A2(
			elm$html$Html$h1,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('not-found-header')
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$i,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('fa fa-exclamation-triangle')
						]),
					_List_Nil),
					elm$html$Html$text(' 404')
				])),
			A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('not-found')
				]),
			_List_fromArray(
				[
					elm$html$Html$text('ϑhe page you are looking for does not exist (any longer).')
				]))
		]));
var author$project$Pages$Notes$Init$notesDescription = A2(
	elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			elm$html$Html$text('My personal collection of notes from texts on technical topics')
		]));
var author$project$Pages$Notes$Init$notesHeading = elm$html$Html$text('Notes');
var author$project$Pages$Notes$Init$view = function (model) {
	return A4(author$project$Pages$Init$view, model, author$project$Pages$Notes$Init$notesHeading, author$project$Pages$Notes$Init$notesDescription, '/notes/');
};
var author$project$Pages$Projects$Init$projectsDescription = A2(
	elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			elm$html$Html$text('Below is a list of projects that I have done / am doing at the moment. '),
			elm$html$Html$text('Click on one to see the details. '),
			elm$html$Html$text('Please refer to the '),
			A2(
			elm$html$Html$a,
			_List_fromArray(
				[
					elm$html$Html$Attributes$href('/socials')
				]),
			_List_fromArray(
				[
					elm$html$Html$text('the contacts page')
				])),
			elm$html$Html$text(' if you want to contribute')
		]));
var author$project$Pages$Projects$Init$projectsHeading = elm$html$Html$text('Completed and Ongoing Projects');
var author$project$Pages$Projects$Init$view = function (model) {
	return A4(author$project$Pages$Init$view, model, author$project$Pages$Projects$Init$projectsHeading, author$project$Pages$Projects$Init$projectsDescription, '/projects/');
};
var elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2(elm$core$Dict$map, func, left),
				A2(elm$core$Dict$map, func, right));
		}
	});
var elm$html$Html$button = _VirtualDom_node('button');
var elm$html$Html$form = _VirtualDom_node('form');
var elm$html$Html$input = _VirtualDom_node('input');
var elm$html$Html$textarea = _VirtualDom_node('textarea');
var elm$html$Html$Attributes$action = function (uri) {
	return A2(
		elm$html$Html$Attributes$stringProperty,
		'action',
		_VirtualDom_noJavaScriptUri(uri));
};
var elm$html$Html$Attributes$method = elm$html$Html$Attributes$stringProperty('method');
var elm$html$Html$Attributes$name = elm$html$Html$Attributes$stringProperty('name');
var elm$html$Html$Attributes$placeholder = elm$html$Html$Attributes$stringProperty('placeholder');
var elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		elm$core$String$fromInt(n));
};
var elm$html$Html$Attributes$type_ = elm$html$Html$Attributes$stringProperty('type');
var author$project$Pages$Socials$Init$view = function (model) {
	return A2(
		elm$html$Html$div,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('socials-container')
			]),
		_List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('socials-desc')
					]),
				_List_fromArray(
					[
						elm$html$Html$text('Here is a list of places where you can find me or my work at:')
					])),
				A2(
				elm$html$Html$ul,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('socials-list')
					]),
				elm$core$Dict$values(
					A2(
						elm$core$Dict$map,
						F2(
							function (k, v) {
								return A2(
									elm$html$Html$li,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('socials-item')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$href(v)
												]),
											_List_fromArray(
												[
													elm$html$Html$text(' ' + k)
												]))
										]));
							}),
						model))),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('contact-me')
					]),
				_List_fromArray(
					[
						elm$html$Html$text('Alternatively, send me an email with the form below')
					])),
				A2(
				elm$html$Html$form,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('contact-form'),
						elm$html$Html$Attributes$action('https://formspree.io/f/xojoanby'),
						elm$html$Html$Attributes$method('POST')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('contact-form-section')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$input,
								_List_fromArray(
									[
										elm$html$Html$Attributes$type_('email'),
										elm$html$Html$Attributes$name('email'),
										elm$html$Html$Attributes$placeholder('Your email')
									]),
								_List_Nil)
							])),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('contact-form-section')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$textarea,
								_List_fromArray(
									[
										elm$html$Html$Attributes$name('message'),
										elm$html$Html$Attributes$rows(10),
										elm$html$Html$Attributes$placeholder('Your message')
									]),
								_List_Nil)
							])),
						A2(
						elm$html$Html$button,
						_List_fromArray(
							[
								elm$html$Html$Attributes$type_('submit')
							]),
						_List_fromArray(
							[
								elm$html$Html$text('Send')
							]))
					]))
			]));
};
var author$project$Main$getPageView = function (model) {
	var _n0 = model.a0;
	switch (_n0.$) {
		case 1:
			var homeModel = _n0.a;
			return author$project$Pages$Home$Init$view(homeModel);
		case 2:
			var projectsModel = _n0.a;
			return A2(
				elm$html$Html$map,
				author$project$Main$GotProjectsMsg,
				author$project$Pages$Projects$Init$view(projectsModel));
		case 3:
			var blogModel = _n0.a;
			return A2(
				elm$html$Html$map,
				author$project$Main$GotBlogMsg,
				author$project$Pages$Blog$Init$view(blogModel));
		case 4:
			var notesModel = _n0.a;
			return A2(
				elm$html$Html$map,
				author$project$Main$GotNotesMsg,
				author$project$Pages$Notes$Init$view(notesModel));
		case 5:
			var socialsModel = _n0.a;
			return author$project$Pages$Socials$Init$view(socialsModel);
		default:
			return author$project$Pages$NotFound$view;
	}
};
var author$project$Main$view = function (model) {
	return {
		bz: _List_fromArray(
			[
				A2(
				elm$html$Html$map,
				author$project$Main$GotSidebarMsg,
				author$project$Components$Sidebar$view(model.x.T)),
				A2(
				author$project$Components$Body$view,
				model.x.bz,
				author$project$Main$getPageView(model))
			]),
		br: 'dirichletian'
	};
};
var elm$browser$Browser$application = _Browser_application;
var elm$json$Json$Decode$value = _Json_decodeValue;
var author$project$Main$main = elm$browser$Browser$application(
	{bP: author$project$Main$init, bX: author$project$Main$ChangedUrl, bY: author$project$Main$ClickedLink, b5: author$project$Main$subscriptions, b9: author$project$Main$update, cb: author$project$Main$view});
_Platform_export({'Main':{'init':author$project$Main$main(elm$json$Json$Decode$value)(0)}});}(this));